{
  "LIST_FILTER_ROW": {
  	"aria_label": "filters",
  	"status": "status",
  	"open_amount": "openstaand saldo",
  	"more": "+{{count}} meer",
  	"search_tag": "zoek tag…",
  	"or_hint": "een van deze tags",
  	"clear_all": "alles wissen",
  	"clear_filters": "filters wissen",
  	"no_results_filters": "geen boekingen met deze filters.",
  	"clear_chip": "wis {{name}}",
  	"bookings_total": "{{count}} boekingen",
  	"bookings_total_one": "{{count}} boeking",
  	"flights_total": "{{count}} vluchten",
  	"flights_total_one": "{{count}} vlucht",
  	"search_hint": "Enter om te zoeken · datum = jjjj-mm-dd",
  	"more_actions": "meer acties",
  	"period": "periode",
  	"period_all": "alle",
  	"period_today": "vandaag",
  	"period_this_week": "deze week",
  	"period_this_month": "deze maand",
  	"period_next_month": "volgende maand",
  	"period_custom": "aangepast…",
  	"free_spots": "vrije plaatsen",
  	"free_spots_all": "alle",
  	"free_spots_min": "minstens {{n}}",
  	"free_spots_overbooked": "overboekt"
  },
  "SEARCH_ELSEWHERE": {
  	"none_in_filter": "geen resultaten in \"{{filter}}\" voor \"{{search}}\".",
  	"found_in": "wel gevonden in:",
  	"also_found_in": "ook gevonden in"
  },
  "LOGIN": {
    "email_me_a_login_link": "stuur me een aanmeldlink",
    "login_link_sent": "er is een aanmeldlink verzonden",
    "signed_in_elsewhere_title": "je bent aangemeld",
    "signed_in_elsewhere": "je bent aangemeld via de link in een ander tabblad — je kunt dit tabblad sluiten",
    "continue_here": "hier verdergaan",
    "completing_signin": "je wordt aangemeld…",
    "confirm_email_for_link": "bevestig je e-mailadres om het aanmelden te voltooien",
    "continue": "doorgaan",
    "login_link_invalid": "deze aanmeldlink is niet meer geldig. vraag een nieuwe aan.",
    "request_new_link": "nieuwe link aanvragen"
  },
  "MONTY": {
      "requested_prefix": "klant vraagt",
      "requested_MATCH": "{{date}} → vlucht {{flight}} ({{free}} vrij)",
      "requested_CURRENT": "{{date}} → staat al op deze vlucht ({{flight}})",
      "requested_FULL": "{{date}} → volzet in de zone",
      "requested_NOT_PLANNED": "{{date}} → nog geen vlucht gepland in de zone",
      "requested_PRIVATE_ONLY": "{{date}} → enkel een privévlucht ({{flight}})",
      "requested_OUT_OF_VALIDITY": "{{date}} → na de geldigheid van de boeking",
      "requested_PAST": "{{date}} → in het verleden",
      "date_conflict": "weekdag en datum klopten niet samen, de datum is gebruikt",
      "needs_review": "controleer de tekst: {{items}} komt niet uit de vluchtgegevens",
      "tag_P": "planning",
      "tag_Q": "vraag",
      "tag_W": "weer",
      "tag_C": "klacht / gevoelig",
      "tag_N": "geen actie nodig",
      "action_accepted_line": "actie uitgevoerd via Monty",
    "accept": "accepteren",
      "dismiss": "actie afwijzen",
      "action_repick": "klik om een andere vlucht te kiezen",
      "action_CONFIRM_ON_FLIGHT": "boeking bevestigen op",
      "action_MOVE_TO_FLIGHT": "boeking verplaatsen naar",
      "action_REMOVE_FROM_FLIGHT": "boeking verwijderen van",
      "failure_FLIGHT_FULL": "vlucht is vol of afgesloten — kies een andere vlucht",
      "failure_FLIGHT_CANCELLED": "vlucht werd geannuleerd — kies een andere vlucht",
      "failure_PROPOSAL_NOT_OPEN": "voorstel is niet meer open",
      "proposal_strip": "voorstel van Monty — pas aan of verstuur",
      "proposal_clear": "voorstel verwijderen",
      "proposal_insert": "voorstel beschikbaar — klik om in te voegen",
      "settings_panel_title": "Monty - jouw AI-assistent",
      "settings_key_title": "Anthropic API-sleutel",
      "settings_key_note": "Monty werkt op je eigen Anthropic-account: vul je API-sleutel in om te activeren. De kosten lopen via je eigen account.",
      "settings_key_label": "API-sleutel",
      "settings_key_save": "opslaan & valideren",
      "settings_key_replace": "wijzigen",
      "settings_key_remove": "verwijderen",
      "status_active": "actief",
      "status_no_credits": "geen tegoed meer — Monty is gepauzeerd",
      "status_no_credits_note": "nieuwe berichten krijgen tijdelijk geen label; Monty gaat automatisch verder zodra er terug tegoed is",
      "status_key_invalid": "sleutel ongeldig — Monty is inactief",
      "status_off": "niet geconfigureerd",
      "settings_usage_title": "verbruik & kosten",
      "settings_usage_note": "schatting op basis van tokenverbruik en lijstprijzen; facturatie loopt via je eigen Anthropic-account",
      "usage_month": "maand",
      "usage_classifications": "classificaties",
      "usage_proposals": "voorstellen",
      "usage_cost": "geschatte kost",
      "usage_learn_runs": "leersessies",
      "instructions_title": "instructies per categorie",
      "instructions_note": "beschrijf hoe je elk type bericht doorgaans beantwoordt (toon, standaardinfo, afspraken) — Monty volgt dit bij het opstellen van voorstellen",
      "instructions_manual_label": "jouw instructies",
      "instructions_learned_title": "voorstel uit geschiedenis — controleer en pas aan",
      "instructions_learned_from": "op basis van {{count}} beantwoorde berichten uit de laatste {{months}} maanden",
      "instructions_learned_note": "Monty gebruikt dit voorstel nu al samen met jouw eigen instructies. Neem het over in jouw instructies om het definitief te maken — anders vervangt een volgende leersessie dit voorstel.",
      "instructions_adopt_draft": "overnemen in mijn instructies",
      "instructions_discard_draft": "voorstel verwijderen",
      "instructions_save": "opslaan",
      "learn_title": "leer uit geschiedenis",
      "learn_note": "Monty tagt je eerdere gesprekken en destilleert per categorie hoe je doorgaans antwoordt; het resultaat verschijnt hierboven als aanpasbaar voorstel",
      "learn_button": "leer uit geschiedenis",
      "learn_month": "maand",
      "learn_months": "maanden",
      "learn_messages": "berichten",
      "learn_estimated_cost": "geschatte kost",
      "learn_warning": "deze sessie verbruikt het tegoed van je eigen Anthropic-account",
      "learn_start": "start leersessie",
      "learn_cancel_dialog": "annuleren",
      "learn_no_messages": "geen berichten in deze periode",
      "learn_progress": "{{done}} van {{total}} berichten verwerkt",
      "learn_phase_TAGGING": "geschiedenis taggen",
      "learn_phase_DISTILLING": "instructies destilleren",
      "learn_state_RUNNING": "leersessie bezig",
      "learn_state_COMPLETED": "leersessie afgerond",
      "learn_state_CANCELLED": "leersessie geannuleerd",
      "learn_state_STOPPED_NO_CREDITS": "gestopt — tegoed op; reeds gezette tags blijven bewaard",
      "learn_resume": "hervatten",
      "learn_cancel_run": "sessie annuleren",
      "learn_cost_so_far": "verbruikt"
  },
	"CHARTS": {
		"last1months": "1m",
		"last3months": "3m",
		"last6months": "6m",
		"last12months": "12m",
		"last24months": "24m"
	},
	"VALIDATIONS": {
		"checkin_edit": "bewerken",
		"checkin_clear_signoff": "handtekening wissen",
		"checkin_clear_signoff_confirm": "Handtekening van de piloot wissen? De vlucht telt als niet afgetekend tot er opnieuw getekend wordt.",
		"checkin_manual_value": "handmatig gezet door de piloot tijdens check-in",
		"checkin_signed_off": "de vlucht is al afgetekend - wis eerst de handtekening",
		"checkin_flight_not_found": "vlucht niet gevonden",
		"checkin_invalid_hour": "ongeldig vertrekuur",
		"checkin_invalid_tempTakeoff": "temperatuur bij opstijgen moet tussen -40 en 50 °C liggen",
		"checkin_invalid_tempBalloon": "ballontemperatuur moet tussen 50 en 150 °C liggen",
		"checkin_invalid_windGl": "grondwind moet tussen 0 en 60 kt liggen",
		"checkin_invalid_windGlDirection": "windrichting moet tussen 0 en 360° liggen",
		"checkin_invalid_weatherQnh": "QNH moet tussen 900 en 1100 hPa liggen",
		"checkin_invalid_plannedFlightTime": "geplande vluchttijd moet positief zijn en mag de maximale vluchttijd niet overschrijden",
		"load_failed": "deze gegevens konden niet geladen worden",
		"error": "Onverwachte fout, controleer alle velden",
		"minimun_one_adult_or_Child_is_required": "Je hebt minimun één volwassen of kind nodig",
		"error_tenant_does_not_exist": "de opgegeven operator bestaat niet",
		"not_possible": "deze actie is niet mogelijk",
		"required": "verplicht veld",
		"tenant_is_required": "operator is een verplicht veld",
		"email_is_required": "email is een verplicht veld",
		"wrong_password": "foutief wachtwoord",
		"check_email": "controleer het email adres",
		"International_phone_format": "internationaal formaat vereist",
		"email": "ongeldig email adres",
		"duplicate_email": "email adres bestaat reeds",
		"no_integer": "geen geldig geheel getal",
		"positive_number": "moet nul of positief zijn",
		"lift_orange_below_red": "de groene grens moet minstens de oranje grens zijn",
		"token_has_expired": "login is niet meer geldig",
		"wrong_credentials": "foute login gegevens",
		"flight_date_in_past": "deze vlucht ligt in het verleden",
		"save_or_cancel_updates": "bewaar of annuleer eerst je wijzigingen",
		"warning": "opgelet",
		"capacity_must_be_between_0_and_30": "capaciteit moet tussen 0 en 100 liggen",
		"validation_errors": "verbeter eerst de fouten in het formulier",
		"mismatch_location": "regio past niet",
		"mismatch_availability": "tijdstip past niet",
		"mismatch_start_date": "vlucht datum te vroeg",
		"mismatch_end_date": "vlucht datum te laat",
		"mismatch_type": "vlucht type past niet",
		"mismatch_flight": "toegevoegd aan andere vlucht",
		"missing_function": "deze functie wordt binnenkort verwacht",
		"attachment_not_found": "bestand niet gevonden in opslag",
		"invalid_file_only_pdf_jpg_png_max_10MB": "Ongeldig bestand: enkel PDF, JPG en PNG tot 10 MB worden aanvaard.",
		"invalid_file_too_large_max_10MB": "Bestand is te groot: de maximumgrootte is 10 MB.",
		"no_category": "geen passagierscategorieën gevonden, ga eerst naar instellingen om 1 of meerdere categorieën toe te voegen.",
		"no_region": "geen regio's gevonden, ga eerst naar regio's om 1 of meerdere regio's toe te voegen.",
		"lift_mismatch": "er zijn onvoldoende gegevens om de lift te kunnen berekenen",
		"lift_missing_location": "locatie ontbreekt",
		"lift_missing_balloon_volume": "volume van ballon is niet gekend",
		"lift_missing_balloon_weight": "gewicht van ballon is niet gekend of onvolledig",
		"lift_missing_pilot": "piloot is niet gekend",
		"lift_missing_pilot_weight": "het gewicht van de piloot is niet gekend",
		"lift_missing_temp_takeoff": "de temperatuur bij opstijgen is niet gekend",
		"lift_missing_pressure": "de luchtdruk bij opstijgen is niet gekend",
		"mobile_missing_signature": "niet alle passagiers zijn ingecheckt",
		"mobile_missing_forecast": "Geen weersvoorspelling beschikbaar",
		"mobile_documents": "vervaldata documenten",
		"mobile_doc_insurance": "verzekering tot",
		"mobile_doc_airworthiness": "luchtwaardig tot",
		"mobile_doc_license": "licentie piloot tot",
		"mobile_clear": "opnieuw",
		"mobile_agree": "akkoord",
		"mobile_self_sign": "plaats X",
		"click_to_fly_all": "bevestig alles",
		"click_to_fly": "bevestigen",
		"pax_good_to_fly": "pax ok",
		"lift_good_to_fly": "lift ok",
		"fuel_good_to_fly": "brandstof ok",
		"weather_good_to_fly": "weer ok",
		"docs_good_to_fly": "documenten ok",
		"pilot_sign_off": "bevestig alle parameters en teken dit scherm af voor goedkeuring. Commentaar op de parameters kan toegevoegd te worden.",
		"agree": "akkoord",
		"redo": "opnieuw",
		"new_version": "er is een nieuwe versie",
		"reload_the_app": "wil je Quick Release nu opnieuw starten?",
		"new_features_available": "{0} nieuwe functie(s) beschikbaar",
		"show_new_features": "Toon nieuwe functies",
		"forget_device": "Log uit en vergeet toestel",
		"bookings_with_open_amount": "reservaties met openstaand saldo",
		"bookings_to_confirm": "te bevestigen",
		"bookings_bookmarked": "bladwijzers",
		"cylinder_capacity_must_be_between_0_and_200": "capaciteit moet tussen 0 en 200 liggen",
		"cylinder_weight_must_be_between_0_and_200": "het gewicht moet tussen 0 en 200 liggen",
		"unauthorized": "you are not authorized for this operation",
		"disconnected": "connectivity problem, do you have internet?",
		"possible_duplicates": "er is mogelijk een dubbele reservatie (dezelfde contactgegevens werden gevonden in een andere open reservatie)",
		"possible_duplicates_with_flights": "er is mogelijk een dubbele reservatie met 2 verschillende vluchtdata",
		"duplicate_flight": "ballon is dubbel ingepland",
		"duplicate_pilot": "piloot is dubbel ingepland",
		"crew_ready_changed_warning": "De crew is reeds op de hoogte gebracht. Gelieve hen te informeren over de wijzigingen."
	},
	"HINTS": {
		"add_country_code": "Voeg landcode toe +32...",
		"no_contact_selected": "Selecteer een contactpersoon",
		"message_filter": "filter aan/uit",
		"role_can_only_be_set_after_creation": "de rol kan pas ingesteld worden na het aanmaken",
		"please_wait": "even geduld"
	},
	"SKEYES": {
		"ballooning_bulletin": "Ballooning Bulletin",
		"load": "Skeyes login",
		"disclaimer": "Het Ballooning Bulletin is een dienst van Skeyes.",
		"instructions": "Geef je Skeyes login en paswoord in om het Ballooning Bulletin te raadplegen. Enkel piloten met een geldige licentie kunnen het Ballooning Bulletin raadplegen. De gegevens worden enkel gebruikt om het Ballooning Bulletin te raadplegen en worden niet opgeslagen. Gebruiksvoorwaarden Skeyes zijn van toepassing.",
		"username": "Skeyes Username",
		"password": "Skeyes Password",
		"loaded_by": "ingeladen door",
		"loading_can_take_up_to_15sec": "het inladen kan tot 15 seconden duren",
		"error": "Onverwachte fout, controleer alle velden",
		"slot_warning": "dit bulletin is mogelijk niet van toepassing voor deze vlucht"
	},
	"APPLICATION": {
		"domain": "domein",
		"Du": "nederlands (Nederland)",
		"Nl": "nederlands (België)",
		"Fr": "français (french)",
		"En": "english",
		"Es": "español (spanish)",
		"Cs": "cesky (czech)",
		"It": "Italiano (Italian)",
		"De": "Deutsch (German)",
		"Pt": "Português (portuguese)",
		"Lv": "Latviešu (Latvian)",
		"date": "datum",
		"name": "naam",
		"call_sign": "call sign",
		"capacity": "capaciteit",
		"flight_count": "aantal vluchten",
		"sku": "beschrijving",
		"unit_count": "eenheden",
		"unit_cost": "prijs per eenheid",
		"send_sms": "verzonden sms",
		"receive_sms": "ontvangen sms",
		"sms_count": "aantal sms",
		"payments": "betalingen",
		"running_month": "huidige maand",
		"history_balloons": "historiek ballonnen",
		"history_sms": "historiek sms",
		"total_cost": "prijs",
		"sorry": "sorry",
		"flights": "vluchten",
		"calendar": "kalender",
		"bookings": "reservaties",
		"vouchers": "bonnen",
		"balloons": "ballonnen",
		"crew": "crew en piloten",
		"regions": "regio's",
		"locations": "locaties",
		"reports": "rapporten",
		"logbooks": "logboeken",
		"admin": "beheer",
		"releasenotes": "release notes",
		"subscription": "abonnement",
		"log_sms_in": "inkomende SMS",
		"log_sms_out": "uitgaande SMS",
		"settings": "instellingen",
		"cylinders": "gasflessen",
		"language": "taal",
		"sms": "SMS",
		"help": "help",
		"search": "zoek",
		"live_filter_off": "Gebruik de search button om te zoeken. Als er meer dan 25 zoek resultaten getoond moeten worden, dan is live search niet mogelijk",
		"add_booking": "nieuwe reservatie",
		"add_voucher": "nieuwe bon",
		"add_flight": "nieuwe vlucht",
		"privacy_policy": "privacy beleid",
		"terms": "voorwaarden",
		"sign in to use your Quick Release Account": "meld je aan voor je Quick Release Account",
		"your username and password didn't match": "er is een probleem met je gebruikersnaam of wachtwoord",
		"please try again": "probeer opnieuw",
		"username": "gebruiker",
		"password": "wachtwoord",
		"sign_in": "log in",
		"send_PIN": "stuur code",
		"use_PIN": "gebruik SMS code",
		"pin_successfully_sent": "PIN met succes verstuurd",
		"use_password": "gebruik wachtwoord",
		"send_email": "stuur email",
		"email": "email",
		"send_email_to": "selecteer bestemmeling",
		"select_template": "selecteer template",
		"sent": "verzonden",
		"waiting": "bezig met verzenden",
		"error": "verzenden mislukt",
		"pin": "code",
		"verification_code": "Beveiligingscode",
		"verification_code_subtitle": "Voer de 6-cijferige code in die je hebt ontvangen via email",
		"resend_code": "code opnieuw versturen",
		"resend_code_disabled": "code opnieuw versturen in 30 seconden",
		"code_required": "Code is vereist",
		"code_pattern": "Moet 6 cijfers zijn",
		"verify_code": "code verifiëren",
		"trust_device": "Dit toestel zal 60 dagen vertrouwd worden. In de komende 60 dagen is er geen verificatie code nodig om je aan te melden",
		"sign_out": "log uit",
		"save": "bewaar",
		"save_and_back": "bewaar en terug",
		"cancel": "annuleer",
		"previous": "vorige",
		"delete": "verwijder",
		"refresh": "vernieuw",
		"new_version_available": "er is een nieuwe versie van Quick Release beschikbaar",
		"today": "vandaag",
		"classic": "terug naar oude interface",
		"month": "maand",
		"week": "week",
		"morning_flights": "ochtendvluchten vandaag",
		"evening_flights": "avondvluchten vandaag",
		"morning_flights_tomorrow": "ochtendvluchten morgen",
		"yesterday_flights": "avondvluchten gisteren",
		"action": "actie",
		"version": "versie",
		"messages": "berichten",
		"assign": "toewijzen",
		"assigned": "toegewezen",
		"assign_to": "vlucht toewijzen aan",
		"close": "sluit",
		"apps": "configuraties",
		"more": "meer"
	},
	"CALENDAR": {
		"MATRIX": {
			"plan_flight": "vlucht plannen",
			"flyability_flight_location": "flyability-waarschuwing voor de locatie van deze vlucht",
			"pilot": "piloot",
			"driver_be": "chauffeur (BE)",
			"crew": "crew",
			"occupancy": "bezetting bevestigd / toegevoegd",
			"cancelled": "geannuleerd",
			"conflict_tooltip": "meerdere vluchten op hetzelfde dagdeel — klik om op te lossen in de dagplanner",
			"morning": "ochtend",
			"evening": "avond",
			"weather_anchor": "weer & zon: standaardlocatie",
			"weather_anchor_tooltip": "dagweer en zontijden gelden voor de standaardlocatie; vluchtcellen tonen de flyability van hun eigen locatie",
			"no_default_location": "stel een standaardlocatie in om dagweer en zontijden te zien",
			"sunrise_tooltip": "zonsopgang op de standaardlocatie",
			"sunset_tooltip": "zonsondergang op de standaardlocatie",
			"open_bookings": "open reservaties",
			"load_more": "meer laden",
			"already_assigned_tooltip": "al toegewezen aan deze vlucht — elders neerzetten verplaatst ze, nooit een dubbel",
			"open": "open",
			"events": "events",
			"seats": "plaatsen",
			"move_overflow_title": "onvoldoende capaciteit",
			"move_overflow_body": "De doelballon heeft minder plaatsen dan het aantal passagiers op deze vlucht. Toch verplaatsen?",
			"flights": "vluchten",
			"available": "beschikbaar",
			"no_availability_info": "geen beschikbaarheidsinfo voor dit dagdeel",
			"edit_hint": "klik op een infoveld van een kaart om het in een pop-up aan te passen — volledig bewerken via vluchtdetail",
			"location": "locatie",
			"pilot_crew": "piloot & crew",
			"weather": "weer",
			"lift": "lift",
			"comment": "opmerking",
			"edit_in_popup": "aanpassen in pop-up",
			"assign": "— toewijzen",
			"move": "verplaats",
			"flight_detail": "vluchtdetail",
			"drop_bookings_here": "nog geen reservaties — sleep ze hierheen",
			"search_placeholder": "zoek op naam, telefoon of opmerking…",
			"search_hint": "Enter — zoekt server-side",
			"no_open_bookings": "geen open reservaties voor dit dagdeel",
			"waiting_list_hint": "sleep een toegewezen reservatie hierheen om ze los te koppelen",
			"back_to_classic": "terug naar klassiek dashboard",
			"previous_week": "vorige week",
			"next_week": "volgende week",
			"this_week": "deze week",
			"classic_until": "beschikbaar tot 31 maart 2027",
			"try_matrix_banner": "Probeer het nieuwe dashboard met weekplanning — wordt de standaard op 31 maart 2027.",
			"try_matrix": "probeer",
			"create": "aanmaken",
			"hour_derived": "automatisch: zonsopgang/-ondergang op de gekozen locatie, incl. jouw offset",
			"hour": "uur",
			"date": "datum",
			"period": "dagdeel",
			"balloon": "ballon"
		},
		"waiting_list": "wachtlijst",
		"no_bookings_yet": "Nog geen reservaties",
		"drag_and_drop_reservations_here_to_add_to_this_flight": "sleep reservaties naar hier om aan de vlucht toe te voegen",
		"drag_and_drop_reservations_here_to_remove_from_this_flight": "sleep reservaties naar hier om te verwijderen van de vlucht",
		"good_job": "goed gewerkt",
		"all_bookings_are_added_to_a_flight": "alle reservaties werden aan een vlucht toegevoegd",
		"you_cannot_drop_bookings_here": "je kan hier geen reservaties droppen",
		"show_calendar_crew": "toon kalendar van crew",
		"set_month": "zet volledige maand",
		"clear_month": "verwijder alles",
		"plan": "plan",
		"refetch": "vernieuw",
		"show_all_pilots": "toon alle piloten",
		"show_all_crew": "toon alle crew"
	},
	"ACTORS": {
		"COM": "CPL",
		"NCO": "PPL",
		"NOL": "geen licentie",
		"NOA": "geen login",
		"OPR": "operator",
		"CRE": "piloot/crew (enkel toegewezen vluchten)",
		"REP": "rapporten lezen",
		"ASS": "Operator assistent (vluchten & reservaties)",
		"MET": "meteo (enkel vluchten)",
		"user_role": "gebruikersrol",
		"name": "naam",
		"phone": "telefoon",
		"email": "email",
		"used_for_login": "email gebruikt voor login",
		"emailNotifications": "email notificaties",
		"emails_from_the_system_will_be_send_to_this_address": "emails verzonden vanuit het systeem worden naar dit adres gestuurd",
		"driver_license": "rijbewijs",
		"driver_license_none": "geen",
		"pilot_license": "vergunning ",
		"ground_crew": "crew",
		"language": "taal",
		"confirm_message": "bevestig om te verwijderen",
		"confirm": "bevestigen",
		"contacts": "contacten",
		"update": "wijzig",
		"delete": "verwijder",
		"save": "bewaar",
		"add_contact": "voeg contact toe",
		"crew": "crew",
		"pilot": "piloot",
		"add_crew": "voeg crew toe",
		"national_license": "nationale licentie",
		"part_fcl_license": "PART-FCL licentie",
		"license_group_A": "groep A",
		"license_group_B": "groep B",
		"license_group_C": "groep C",
		"license_group_D": "groep D",
		"license_gas": "gasballon",
		"license_number": "licentie nummer",
		"license_expiry_date": "vervaldag licentie / OPC",
		"license_extra_crew": "extra crew",
		"ground_crew_training_expiry_date": "crew training vervalt op",
		"first_aid_expiry_date": "EHBO training vervalt op",
		"fire_extinguisher_expiry_date": "brandblusser training vervalt op",
		"medical_expiry_date": "medische keuring vervalt op",
		"weight": "gewicht",
		"warning_not_current": "Piloot voldoet binnen de 30 dagen niet meer aan de voorwaarden, controleer de vervaldata",
		"error_not_current": "Piloot voldoet niet meer aan de voorwaarden, controleer de vervaldata",
		"assigned_to_flight": "toegewezen aan vlucht",
		"your_flight": "jouw vlucht",
		"your_flights": "jouw vluchten",
		"pilots": "piloten",
		"drivers": "BE-crew"
	},
	"BALLOONS": {
		"upload_photo": "foto opladen",
		"name": "naam",
		"call_sign": "call sign",
		"capacity": "aantal passagiers",
		"total_weight": "totaal gewicht",
		"balloons": "ballonnen",
		"confirm_message": "bevestig om te verwijderen",
		"confirm": "bevestigen",
		"update": "wijzig",
		"delete": "verwijder",
		"save": "bewaar",
		"add_balloon": "voeg ballon toe",
		"group": "groep",
		"MLM": "MTM (Minimum Landing Mass)",
		"MTOM": "MTOM (Maximum Take-Off Mass)",
		"lift_warning_title": "lift-waarschuwingszones",
		"lift_warning_explain": "kleur van het reserve draagvermogen per vaart: twijfelachtig (oranje) vanaf de eerste waarde, goed (groen) vanaf de tweede — onder de oranje grens kleurt de vaart rood. Blauw verschijnt als de vaart onder de MLM zou kunnen landen.",
		"lift_warning_unconfigured": "niet geconfigureerd — enkel een negatieve reserve kleurt rood",
		"lift_zone_red": "te laag",
		"lift_zone_orange": "twijfelachtig",
		"lift_zone_green": "goed",
		"lift_orange_from": "twijfelachtig (oranje) vanaf",
		"lift_good_from": "goed (groen) vanaf",
		"min_fuel": "gemiddeld verbruik (Liter per uur)",
		"liter_per_hour": "liter per uur",
		"fuel": "verbruik bij 20°C en maximum aantal passagiers",
		"envelope": "ballon",
		"envelope_manufacturer": "ballon fabrikant",
		"envelope_type": "ballon type",
		"envelope_volume": "ballon volume",
		"envelope_weight": "ballon gewicht",
		"envelope_hours": "ballon vlieg uren",
		"envelope_inspection_date": "ARC geldig tot",
		"balloon_temp": "max ballon temperatuur",
		"burner": "brander",
		"burner_manufacturer": "brander fabrikant",
		"burner_type": "brander type",
		"burner_weight": "brander gewicht",
		"cylinder_hint": "Bewaar eerst de ballon en voeg daarna gasflessen toe. Zorg ervoor dat je eerst de gasflessen in het systeem aanmaakt. Dezelfde gasflessen kan je gebruiken op meerdere ballonnen",
		"cylinder": "gasflessen",
		"cylinder_manufacturer": "fabrikant",
		"cylinder_volume": "volume",
		"cylinder_count": "aantal flessen",
		"cylinder_empty_weight": "leeg gewicht fles",
		"cylinder_full_weight": "vol gewicht fles",
		"cylinder_total_weight": "totaal gewicht flessen",
		"cylinder_number": "nr",
		"cylinder_serial": "serienummer",
		"basket": "mand",
		"basket_manufacturer": "mand fabrikant",
		"basket_type": "mand type",
		"basket_weight": "mand gewicht",
		"insurance_company": "verzekeringsmaatschappij",
		"insurance_due_date": "vervaldag verzekering",
		"add_cylinder": "voeg gasflessen toe",
		"error_not_current": "Ballon op de grond, pas de vervaldata aan",
		"warning_not_current": "Ballon vervalt binnen 30 dagen, pas de vervaldata aan"
	},
	"VOUCHERS": {
		"status": "status",
		"create_booking": "maak reservatie",
		"available": "beschikbaar",
		"used": "verbruikt",
		"expired": "verlopen",
		"voucher_type": "type",
		"show_all_types": "toon alle types",
		"voucher_reference": "referentie",
		"issue_date": "datum uitgifte",
		"expiry_date": "vervaldatum",
		"contactName": "contact naam",
		"contactPhone": "telefoon",
		"contactLanguage": "taal",
		"contactEmail": "e-mail",
		"contact_city": "stad",
		"recipient_info": "details van de persoon die de voucher zal ontvangen en gebruiken",
		"buyer_info": "details van de persoon die de voucher heeft gekocht",
		"details_info": "specifieke informatie over de voucher zelf",
		"buyer": "aangekocht door",
		"recipient": "ontvanger",
		"recipientName": "naam",
		"recipientPhone": "telefoon",
		"recipientLanguage": "taal",
		"recipientEmail": "e-mail",
		"recipientAddress": "adres",
		"recipientPostalCode": "postcode",
		"recipientCity": "stad",
		"recipientCountry": "land",
		"details": "details",
		"comments": "opmerkingen",
		"paymentAmount": "bedrag",
		"paymentStatus": "betaalstatus",
		"paymentDate": "betaaldatum",
		"adults": "aantal volwassenen",
		"children": "aantal kinderen",
		"external": "extern",
		"external_source": "bron",
		"tickets": "tickets",
		"voucher": "bon",
		"available_vouchers": "beschikbare bonnen",
		"confirm_message": "ben je zeker dat je deze bon wil verwijderen?",
		"unpaid_vouchers": "let op! onbetaalde bonnen",
		"IMPORT": {
			"import": "importeer",
			"upload_csv": "upload CSV",
			"upload_valid_csv_with_this_header": "upload een geldig CSV bestand met de volgende header",
			"example_with_2_adults": "voorbeeld van cadeau bon voor 2 volwassenen",
			"choose_file": "selecteer bestand",
			"check_file": "valideer bestand",
			"check_errors": "verbeter onderstaande fouten",
			"not_a_valid_CSV": "dit is geen geldig bestand",
			"valid_CSV": "geen validatie fouten",
			"click_import": "klik op importeren",
			"number_of_vouchers": "aantal bonnen",
			"import_status": "import status",
			"imported_succesfully": "met succes geïmporteerd",
			"imported_with_errors": "fouten tijdens het importeren",
			"finish": "beëindig",
			"row": "rij",
			"error_more_less_columns": "meer of minder kolommen dan verwacht",
			"error_header": "fout in de header",
			"error_contact_name": "fout in contactName, deze is verplicht",
			"error_contact_phone": "fout in contactPhone, deze is verplicht en van het formaat M:+32...",
			"error_contact_language": "fout in contactLanguage, deze is verplicht",
			"error_voucher_type": "fout in voucher type, deze is verplicht",
			"error_voucher_reference": "fout in voucher reference, deze is verplicht",
			"error_issue_date": "fout in issue date, deze is verplicht en moet een datum zijn in het formaat YYYY-MM-DD",
			"error_expiry_date": "fout in expiry date, deze is verplicht en moet een datum zijn in het formaat YYYY-MM-DD",
			"error_payment_date": "fout in payment date, deze is verplicht en moet een datum zijn in het formaat YYYY-MM-DD",
			"error_payment_status": "fout in payment status, deze is verplicht en moet OPEN of PAID zijn",
			"error_payment_type": "fout in payment type, deze is verplicht één van volgende waardes: NOPA, CASH, WIRE, BANC, CRED, ONLI",
			"error_adults": "fout in adults, dit moet een cijfer zijn",
			"error_children": "fout in children, dit moet een cijfer zijn",
			"error_import": "fout tijdens import",
			"succes_import": "met succes geïmporteerd",
			"cancel": "annuleer"
		}
	},
	"BOOKINGS": {
		"email_export_tooltip_open_amount": "met openstaand saldo",
		"email_passengers": "e-mail passagiers",
		"email_export_tooltip": "exporteer e-mailadressen van passagiers naar CSV",
		"email_export_tooltip_dynamic": "Download alle e-mailadressen van passagiers ({{filter}}){{extras}}",
		"email_export_tooltip_tags": "met tag {{tags}}",
		"email_export_tooltip_search": "die overeenkomen met '{{search}}'",
		"email_export_success": "{{count}} e-mailadressen geëxporteerd",
		"email_export_empty": "geen e-mailadressen om te exporteren",
		"id": "nr",
		"availability": "beschikbaarheid",
		"PERI": "altijd beschikbaar",
		"DATE": "beschikbaar op datum",
		"MOR": "ochtend",
		"EVE": "avond",
		"mo": "ma",
		"tu": "di",
		"we": "wo",
		"th": "do",
		"fr": "vr",
		"sa": "za",
		"su": "zo",
		"save": "bewaar",
		"child": "kind",
		"name": "naam",
		"weight": "gewicht",
		"luggage": "bagage",
		"paymentType": "betalingswijze",
		"paymentReference": "betalingsreferentie",
		"paymentAmount": "bedrag",
		"paymentStatus": "betaalstatus",
		"paymentDate": "betaaldatum",
		"delete": "verwijder",
		"OPEN": "open",
		"UNK": "toegevoegd",
		"INV": "uitgenodigd per sms",
		"CON": "bevestigd",
		"completed": "uitgevoerd",
		"CAN": "geannuleerd",
		"CPP": "privé",
		"COP": "commercieel",
		"NCP": "recreatief",
		"booking_date": "reservatie datum",
		"days_expired": "{{ d }} dagen verlopen",
		"startDate": "start datum",
		"endDate": "eind datum",
		"status": "status",
		"bookingType": "type reservatie",
		"bookingCode": "reservatie code",
		"bookingCodeHint": "klik op de code om de passagiersapp te openen",
		"bookingCodeMissingEmail": "zonder email adres hebben de passagiers geen toegang tot de passagiers app",
		"commentsTitle": "opmerkingen",
		"comments": "interne opmerkingen",
		"pax_comments": "opmerkingen passagier",
		"region": "regio",
		"source": "bron",
		"new_source": "nieuwe bron",
		"you_can_manage_all_sources_in_settings": "je kan alle bronnen beheren in de instellingen",
		"source_validation": "bron is verplicht, min 3, max 50 karakters en moet uniek zijn",
		"source_list_validation": "Kies een bron uit de lijst of maak eerst een nieuwe bron aan",
		"source_list_empty": "geen bronnen gevonden, voeg je eerste bron",
		"locationType": "locatie",
		"REGI": "alle locaties in een regio",
		"FIXE": "specifieke locatie in een regio",
		"PRIV": "privé locatie",
		"logsRemoved": "aantal keer eerder verwijderd uit een vlucht",
		"contactPerson": "contact persoon",
		"contactName": "contact naam",
		"contactPhone": "contact telefoon",
		"contactEmail": "contact email",
		"contactLanguage": "contact taal",
		"action_needed": "actie nodig",
		"answer_flight_yes_no": "Antwoord VLUCHT JA of VLUCHT NEE",
		"flight_yes": "VLUCHT JA",
		"flight_no": "VLUCHT NEE",
		"PAID": "betaald",
		"REFUNDED": "terugbetaald",
		"not_paid": "te betalen",
		"CASH": "contant",
		"COUP": "bon (uit systeem)",
		"VOUC": "bon",
		"NOPA": "geen betaling",
		"CHEQ": "cheque",
		"WIRE": "overschrijving",
		"BANC": "bancontact",
		"CRED": "credit card",
		"ONLI": "online",
		"INVO": "factuur",
		"only_available_with_paymenttype_voucher": "enkel beschikbaar bij betaalwijze bon",
		"bookings": "reservaties",
		"booking": "reservatie",
		"confirm": "bevestigen",
		"update": "wijzig",
		"contact": "contact",
		"passengers": "passagiers",
		"cancel": "annuleer",
		"next": "volgende",
		"flightDate": "vlucht datum",
		"flightPeriod": "vlucht periode",
		"flight_balloon": "vlucht ballon",
		"flight_location": "vlucht locatie",
		"flight_pilot": "vlucht piloot",
		"add_passenger": "voeg passagier toe",
		"messages": "berichten",
		"no_bookings_found": "geen reservaties gevonden",
		"inviteCount": "uitnodigingen",
		"confirm_message": "ben je zeker dat je deze reservatie wil verwijderen?",
		"delete_blocked_on_flight": "Haal deze reservatie eerst van de vaart voor je ze kan verwijderen.",
		"always_available": "altijd beschikbaar vanaf",
		"limited_availability": "beperkte beschikbaarheid vanaf",
		"end_before": "vlucht voor",
		"passenger": "passagier",
		"details": "details",
		"payment_details": "betalingen",
		"address_details": "adres info",
		"disability": "speciale noden",
		"category": "categorie",
		"address": "adres",
		"postalCode": "postcode",
		"city": "stad",
		"country": "land",
		"signature": "handtekening",
		"added_flight": "toegewezen vlucht",
		"select_flight": "selecteer vlucht",
		"no_flight_added": "geen vlucht toegewezen",
		"no_flight_data": "er worden enkel beschikbare ballonnen en vluchten getoond als de locatie specifiek of privé is en de beschikbaarheid op datum is",
		"available_flights": "beschikbare vluchten",
		"no_available_flights": "geen beschikbare vluchten",
		"available_balloons": "beschikbare ballonnen",
		"no_available_balloons": "geen beschikbare ballonnen",
		"totalAmount": "totaal bedrag",
		"paid_amount": "betaald",
		"openAmount": "saldo",
		"prepayment": "voorschot",
		"prepaymentDate": "voorschot datum",
		"passengers_to_pay": "passagier(s) te betalen",
		"default_weight_warning": "Standaard gewicht - bevestiging nodig",
		"passengers_with_default_weight": "{{ count }} passagier(s) met standaard gewicht",
		"confirm_weight": "Gewicht bevestigen",
		"mark_paid": "markeer als voldaan",
		"remove_from_passengerlist": "verwijder van passagierslijst",
		"add_to_passengerlist": "voeg extra passagier toe",
		"checkin_passengers": "terug naar check in passagiers",
		"view_checked_in": "toon ingecheckte passagiers",
		"hide_checked_in": "verberg ingecheckte passagiers",
		"check_in_all": "check in alle passagiers",
		"import": "importeer",
		"upload_csv": "upload CSV",
		"upload_valid_csv_with_this_header": "upload een geldig CSV bestand met de volgende header",
		"example_in_region_with_id_1_with_2_adults_and_0_children": "voorbeeld van reservatie met 2 volwassenen voor de regio met id 1",
		"choose_file": "selecteer bestand",
		"check_file": "valideer bestand",
		"check_errors": "verbeter onderstaande fouten",
		"not_a_valid_CSV": "dit is geen geldig bestand",
		"valid_CSV": "geen validatie fouten",
		"click_import": "klik op importeren",
		"number_of_bookings": "aantal reservaties",
		"number_of_objects_upcoming": "open",
		"number_of_objects_history": "gesloten",
		"import_status": "import status",
		"imported_succesfully": "met succes geïmporteerd",
		"imported_with_errors": "fouten tijdens het importeren",
		"finish": "beëindig",
		"row": "rij",
		"error_more_less_columns": "meer of minder kolommen dan verwacht",
		"error_header": "fout in de header",
		"error_contact_name": "fout in contactName, deze is verplicht",
		"error_contact_phone": "fout in contactPhone, deze is verplicht en van het formaat M:+32...",
		"error_contact_language": "fout in contactLanguage, deze is verplicht",
		"error_region": "fout in region, deze is verplicht en moet het ID bevatten van de regio",
		"error_adults": "fout in adults, dit moet een cijfer zijn",
		"error_children": "fout in children, dit moet een cijfer zijn",
		"error_import": "fout tijdens import",
		"succes_import": "met succes geïmporteerd",
		"flight_confirmation": "vlucht bevestigen",
		"date_filter_is_yyyy-mm-dd": "datum filter = yyyy-mm-dd",
		"FILTER": {
			"standard": "alle actieve",
			"standard_desc": "alles wat nog moet vliegen",
			"toPlan": "nog in te plannen",
			"toPlan_desc": "nog geen vlucht",
			"toConfirm": "te bevestigen",
			"toConfirm_desc": "aangevraagd door de passagier",
			"invited": "uitgenodigd",
			"invited_desc": "wacht op antwoord van de passagier",
			"confirmed": "bevestigd",
			"confirmed_desc": "staat vast op een vlucht",
			"expired": "verlopen",
			"expired_desc": "geldigheid voorbij, nog niet gevlogen",
			"history": "afgesloten",
			"history_desc": "gevlogen of geannuleerd"
		},
		"import_bookings": "importeer boekingen (CSV)",
		"expired_on_flight_date": "niet meer geldig op de vluchtdatum",
		"flight_confirmed": "vlucht bevestigd",
		"invited_waiting_answer": "uitgenodigd, wachtend op antwoord",
		"MERGE": {
			"merge": "voeg samen",
			"load": "laad",
			"restart": "begin opnieuw",
			"select_booking": "selecteer reservaties",
			"select_booking_hint": "de linkse reservatie zal verwijderd worden, de rechtse reservatie zal behouden blijven",
			"merge_booking": "voeg reservaties samen",
			"merge_booking_hint": "geef je akkoord om te verwijderen alvorens te bewaren",
			"booking_id_to_delete": "reservatie id om te verwijderen",
			"booking_id_to_merge": "reservatie id om samen te voegen",
			"error_loading": "fout bij het laden, kies een andere reservatie id of probeer opnieuw",
			"warning_to_switch": "waarschuwing: je kiest ervoor om de meest recente reservatie (links) te verwijderen",
			"save_and_delete": "bewaar deze reservatie en verwijder",
			"confirm_to_delete": "akkoord om te verwijderen",
			"replace": "vervang",
			"add": "voeg samen",
			"undo": "herstel",
			"fields_are_identical": "velden zijn identiek",
			"remove": "verwijder"
		},
		"LOG": {
			"logbook": "logboek",
			"outbox": "Verzonden e-mails",
			"only_logs_from_UI": "gebeurtenissen uit Quick Release (niet vanuit UP of via website integratie)",
			"ADDE": "toegevoegd aan de vlucht",
			"REMO": "verwijderd uit de vlucht",
			"CONF": "bevestigd voor de vlucht",
			"cancel": "vlucht geannuleerd, terug naar wachtlijst",
			"COMP": "vlucht uitgevoerd, reservatie afgesloten",
			"INVI": "uitgenodigd per MSG voor deelname aan de vlucht",
			"CREA": "reservatie aangemaakt in het systeem",
			"update": "reservatie details gewijzigd",
			"DELE": "reservatie verwijderd uit het systeem",
			"MAIL": "email verstuurd",
			"TRANSFER": "verplaatst naar een andere mand",
			"view_email": "toon email",
			"flight": "vlucht"
		},
		"age": "leeftijd",
		"age_amount": "jaar",
		"transport": "vervoer",
		"invoice_name": "factuur naam",
		"vat_number": "btw nummer"
	},
	"COMMUNICATIONS": {
		"RETENTION": {
			"title": "berichten bewaren",
			"explanation": "Kies hoelang berichten bewaard blijven. Oudere berichten verdwijnen meteen van het dashboard en worden na 90 dagen definitief verwijderd — binnen die 90 dagen kan je ze terughalen door de instelling terug te zetten. Berichten van open reservaties blijven altijd bewaard. Als verwerkingsverantwoordelijke kies en verantwoord je zelf de bewaartermijn.",
			"closedBookings": "afgesloten reservaties",
			"crew": "crew",
			"never": "nooit (altijd bewaren)",
			"years": "jaar",
			"year": "jaar",
			"recommended": "aangeraden: 2 jaar",
			"recommendedShort": "aangeraden",
			"confirmTitle": "oude berichten verwijderen?",
			"confirmBody": "{{total}} berichten ({{closedBookingMessages}} van afgesloten reservaties, {{crewMessages}} van crew) verdwijnen nu en worden na 90 dagen definitief verwijderd. Binnen die 90 dagen kan je ze terughalen door de instelling terug te zetten; daarna zijn ze onherroepelijk weg.",
			"policyClosedYears": "Berichten van afgesloten reservaties worden verwijderd zodra het bericht zelf ouder is dan {{years}} jaar.",
			"policyClosedNever": "Berichten van afgesloten reservaties blijven voor altijd bewaard. Let op: hierdoor kan geen nieuwe WhatsApp-verbinding gemaakt worden.",
			"policyCrewYears": "Crewberichten worden verwijderd zodra het bericht zelf ouder is dan {{years}} jaar.",
			"policyCrewNever": "Crewberichten blijven voor altijd bewaard.",
			"pendingDeletion": "{{count}} berichten staan klaar voor verwijdering — over {{days}} dagen worden ze definitief verwijderd.",
			"connectBlocked": "Om WhatsApp te verbinden moet eerst een bewaartermijn voor berichten van afgesloten reservaties ingesteld zijn (zie \"berichten bewaren\" hieronder)."
		},
		"sent_at": "verzonden om",
		"phone": "telefoon",
		"name": "naam",
		"text": "tekst",
		"status": "status",
		"message_id": "bericht ID",
		"message_price": "bericht prijs",
		"network": "netwerk",
		"remaining_balance": "resterend saldo",
		"received_at": "ontvangen om",
		"msisdn": "msisdn",
		"message_timestamp": "tijdstip bericht",
		"keyword": "trefwoord",
		"pilot_invitation_sms": "MSG aan piloten",
		"crew_invitation_sms": "MSG aan crew",
		"checkin_notification_sms": "check-in uitnodiging",
		"booking_confirmation_sms": "reservatie bevestiging",
		"passenger_invitation_sms": "MSG aan passagiers",
		"cancel_sms": "annulatie MSG",
		"reminder_sms": "herinnering MSG",
		"reminder_wa": "herinnering WhatsApp",
		"sms_in": "inbound sms",
		"messages": "berichten",
		"flight": "vlucht",
		"booking": "reservatie",
		"crew": "crew",
		"sms_out": "outbound sms",
		"to": "naar",
		"unanswered_messages": "onbeantwoorde berichten",
		"mark_all_as_read": "markeer alle {0} berichten als gelezen",
		"mark": "markeer",
		"mark_all": "markeer alles",
		"mark_paid": "markeer betaald",
		"mark_not_paid": "markeer niet betaald",
		"messages_as_read": "berichten als gelezen",
		"you": "jij",
		"mail_copy": "E-mail overzicht",
		"action_succeed": "actie succesvol",
		"accepted": "geaccepteerd",
		"delivered": "afgeleverd",
		"sent": "verzonden",
		"failed": "niet afgeleverd",
		"unknown": "reden niet gekend",
		"retry": "probeer opnieuw",
		"wrongnumber": "verkeerd nummer",
		"none": "geen",
		"fallback_hint": "WhatsApp offline — SMS-tegoed beschikbaar. Schakel SMS-fallback in via instellingen.",
		"WHATSAPP": {
			"CHANNEL": {
			    "chooser": "WhatsApp-kanaal",
			    "free": "WhatsApp gratis",
			    "freeHint": "gekoppeld toestel — gratis, maar niet-officieel; Meta kan het blokkeren",
			    "business": "WhatsApp Business",
			    "businessHint": "officieel Meta-kanaal via je eigen Meta-account — geen blokkeringen, betalend per bericht",
			    "active": "actief",
			    "settingUp": "wordt ingesteld",
			    "freeInactiveExplain": "WhatsApp Business is nu je actieve kanaal. Wil je terug naar WhatsApp gratis, dan wordt je nummer losgekoppeld van de Meta-API en koppel je daarna je telefoon opnieuw met een QR-code. SMS-fallback vangt de overgang op. Let op: het gratis kanaal kan opnieuw door Meta geblokkeerd worden."
			},
			"CLOUD": {
			    "dialogWindowNote": "Ontvangers die je de voorbije 24 uur niet berichtten, krijgen de goedgekeurde sjabloontekst; je aanpassingen bereiken enkel ontvangers binnen het 24-uursvenster.",
			    "windowAllOpen": "Alle ontvangers zitten binnen het 24-uursvenster — je tekst wordt exact zo via WhatsApp verstuurd.",
			    "windowSomeClosed": "{{count}} van {{total}} ontvanger(s) zit(ten) buiten het 24-uursvenster — zij krijgen de goedgekeurde sjabloontekst.",
			    "windowEditedWarning": "Let op: je hebt de tekst aangepast. De {{count}} ontvanger(s) buiten het 24-uursvenster krijgen tóch de GOEDGEKEURDE SJABLOONTEKST — je aanpassing bereikt enkel ontvangers binnen het venster.",
			    "auxTemplateOutOfWindow": "Ontvangers buiten het 24-uursvenster krijgen de UP-link en de vaartvoorstellen als vast sjabloonbericht (tekst bepaald door Quick Release, niet aanpasbaar).",
			    "noFlightTypesHidden": "Deze reservatie heeft nog geen vaart gepland — sjablonen met vaartgegevens (uitnodiging, herinnering, check-in, annulatie) zijn daarom verborgen.",
			    "windowClosedFreeform": "Buiten 24u-venster — gebruik een sjabloon.",
			    "templatePickerButton": "sjabloon",
			    "title": "WhatsApp-kanaal",
			    "subtitle": "Kies hoe WhatsApp-berichten verstuurd worden: WhatsApp gratis (gekoppeld toestel) of WhatsApp Business (officieel, via je eigen Meta-account). Wisselen kan in beide richtingen.",
			    "intro": "WhatsApp Business verstuurt je berichten via de officiële Meta-API: geen gekoppelde telefoon, geen blokkeerrisico en per bericht een afleverbevestiging.",
			    "introBilling": "Het is een betalend kanaal: je koppelt je eigen Meta-bedrijfsaccount met je eigen betaalmethode, en Meta factureert rechtstreeks aan jou. Quick Release rekent niets aan voor deze berichten.",
			    "introCostEstimate": "Schatting op basis van je berichten van de voorbije {{months}} maanden: ± {{cost}} per maand. Gemiddeld verstuurde je {{total}} WhatsApp-berichten per maand, waarvan er ± {{billable}} buiten het 24u-venster vielen — alleen die zijn betalend (± €0,03 per bericht); berichten binnen 24u na een antwoord van de klant zijn gratis.",
			    "introCostEstimateSms": "Schatting op basis van je sms-berichten van de voorbije {{months}} maanden: ± {{cost}} per maand. Gemiddeld verstuurde je {{total}} berichten per maand, waarvan er ± {{billable}} buiten het 24u-venster zouden vallen — alleen die zijn betalend (± €0,03 per bericht); berichten binnen 24u na een antwoord van de klant zijn gratis.",
			    "introTemplates": "Berichten buiten een 24-uursvenster met de klant gaan via je goedgekeurde berichtsjablonen; antwoorden binnen het venster blijven vrije tekst en gratis.",
			    "startSignup": "koppelen met Meta",
			    "reconnectMeta": "Meta-account opnieuw koppelen",
			    "signupCancelled": "De Meta-koppeling is niet afgerond. Je huidige WhatsApp-instellingen zijn ongewijzigd.",
			    "signupSuccess": "WhatsApp Business-account gekoppeld {{phone}}. Je berichtsjablonen worden klaargezet.",
			    "provisioningIntro": "Je Meta-account is gekoppeld. Doorloop de stappen hieronder en activeer daarna WhatsApp Business. Tot dan blijven je berichten het huidige kanaal gebruiken.",
			    "stepWaba": "WhatsApp Business-account gekoppeld",
			    "stepNumber": "Telefoonnummer geregistreerd",
			    "stepPayment": "Betaalmethode toegevoegd in Meta Business Suite",
			    "stepTemplates": "Berichtsjablonen goedgekeurd door Meta",
			    "paymentExplain": "Meta factureert rechtstreeks aan jou op je eigen account. Voeg een betaalmethode toe in Meta Business Suite (Facturering) en bevestig dat hier. Zonder betaalmethode stoppen sjabloonberichten met versturen.",
			    "openMetaBilling": "Meta-facturering openen",
			    "paymentConfirm": "ik heb mijn betaalmethode toegevoegd",
			    "paymentActionNeeded": "Meta meldt een betaalprobleem op je account. Berichten vallen terug op SMS. Controleer je betaalmethode in Meta Business Suite en bevestig hieronder.",
			    "activate": "WhatsApp Business activeren",
			    "activateConfirmTitle": "WhatsApp Business activeren?",
			    "activateConfirmBody": "Vanaf nu gaan je WhatsApp-berichten via de officiële Meta-API op je eigen account. Terugschakelen kan altijd.",
			    "activateConfirmBodyNoPayment": "Je hebt nog geen betaalmethode bevestigd. Gratis berichten werken, maar betalende sjabloonberichten vallen terug op SMS tot Meta een betaalmethode heeft. Toch activeren?",
			    "activated": "WhatsApp Business is actief.",
			    "activeTitle": "WhatsApp Business actief",
			    "messagingTier": "berichtenlimiet",
			    "templatesServing": "{{count}} berichtsjablo(o)n(en) goedgekeurd en in gebruik.",
			    "switchBack": "terug naar WhatsApp gratis",
			    "switchBackConfirmTitle": "Terug naar WhatsApp gratis?",
			    "switchBackConfirmBody": "Je nummer wordt losgekoppeld van de Meta-API en je koppelt het opnieuw als gekoppeld toestel (QR-code). SMS-fallback vangt de overgang op. Let op: het gratis kanaal kan opnieuw door Meta geblokkeerd worden.",
			    "switchedBack": "Teruggeschakeld naar WhatsApp gratis. Koppel je telefoon met de QR-code hieronder.",
			    "statusApproved": "goedgekeurd",
			    "statusPending": "wacht op goedkeuring door Meta",
			    "statusPendingSince": "wacht al {{elapsed}} op goedkeuring door Meta",
			    "statusRejected": "afgekeurd door Meta",
			    "statusBlocked": "tekst moet aangepast worden",
			    "fixWordingHint": "Pas de tekst aan in het scherm berichtsjablonen en bewaar - daarna wordt hij automatisch opnieuw ingediend bij Meta.",
			    "freeChannelNote": "WhatsApp gratis werkt via een gekoppeld toestel op een niet-officiële verbinding; Meta kan die blokkeren of verbreken. Overweeg WhatsApp Business voor een gegarandeerd kanaal.",
			    "metaLinksHint": "Je account, je nummer en de goedkeuring van je sjablonen staan bij Meta — bekijk ze in WhatsApp Manager op je eigen account.",
			    "openMetaAccount": "WhatsApp Manager openen",
			    "openMetaTemplates": "berichtsjablonen bij Meta",
			    "openMetaNumbers": "telefoonnummers bij Meta",
			    "beforeYouStart": "voor je begint, bij Meta",
			    "prereqBusiness": "Een Meta-bedrijfsaccount (Meta Business Portfolio) op naam van je bedrijf — maak het eerst aan als je er nog geen hebt.",
			    "prereqPayment": "Een betaalmethode op dat Meta-account: Meta factureert de betalende berichten rechtstreeks aan jou.",
			    "prereqNumber": "Een telefoonnummer voor WhatsApp: een nieuw nummer, of je huidige WhatsApp Business-nummer (dat blijft werken op je toestel).",
			    "openMetaBusiness": "Meta Business openen",
			    "openManual": "handleiding lezen"
			},
			"settings": "instellingen",
			"whatsapp_OFF": "WhatsApp is uitgeschakeld",
			"whatsapp_OFF_hint": "Contacteer ons om WhatsApp in te schakelen als je een WhatsApp for Business nummer hebt. WhatsApp via je privé nummer wordt niet ondersteund.",
			"whatsapp_ON": "WhatsApp is ingeschakeld",
			"whatsapp_ON_hint": "Alle berichten worden via WhatsApp verstuurd. Kies zelf om SMS als backup te gebruiken, indien WhatsApp niet beschikbaar is voor je klant.",
			"whatsapp_TRIAL": "WhatsApp is in testmodus",
			"whatsapp_TRIAL_hint": "Er zal je telkens worden gevraagd om te kiezen tussen SMS of WhatsApp",
			"fallbackSMS": "fallback naar SMS",
			"fallbackSMS_hint": "gebruik SMS als WhatsApp niet beschikbaar is",
			"fallbackSMS_no_credits": "geen SMS-tegoed beschikbaar. Laad op om SMS-fallback in te schakelen.",
			"connection": "verbinding",
			"device_connected_successfully": "apparaat succesvol verbonden",
			"connect_your_device": "verbind je apparaat",
			"connect": "verbind",
			"disconnect": "verbreek",
			"device": "apparaat",
			"phone": "telefoon",
			"checking_device": "apparaat controleren",
			"not_supported_wa_message": "niet ondersteund WhatsApp bericht"
		}
	},
	"DASHBOARDS": {
		"flights": "vluchten",
		"no_flights": "geen vluchten",
		"upcoming": "aankomende",
		"historical": "beëindigd",
		"this_month": "deze maand",
		"bookings": "reservaties",
		"vouchers": "bonnen",
		"open": "open",
		"completed": "uitgevoerd",
		"expired": "verlopen",
		"idea_voting": "Stem op ideeën",
		"search": "zoek",
		"payments": "betalingen",
		"charts": "grafieken",
		"flights_of_today_and_tomorrow_morning": "alle vluchten van vandaag en morgen ochtend",
		"flights_of_next_7_days": "alle vluchten van de komende 7 dagen",
		"bookings_to_confirm_bookmarked_and_of_today_or_tomorrow_morning": "alle reservaties te bevestigen of beschikbaar vandaag of morgen ochtend of recente reservaties of met een dashboard-tag",
		"basic_charts_of_reservations_and_flights": "standaard grafieken voor reservaties en vluchten",
		"charts_are_no_longer_shown_on_the_dashboard_please_navigate_to_reports": "grafieken worden niet meer op het dashboard getoond, je vindt ze bij rapporten",
		"navigate_to_reports": "Navigeer naar rapporten",
		"most_recent_sms_per_contact": "meest recente berichten",
		"messages_bookings": "berichten reservaties",
		"messages_crew": "berichten crew",
		"messages": "berichten",
		"sms_bookings": "SMS reservaties",
		"sms_crew": "SMS crew",
		"show_all_messages": "alle",
		"show_messags_from_this_flight": "toon enkel deze vlucht",
		"show_messages_from_this_booking": "toon enkel deze reservatie",
		"show_unread": "ongelezen"
	},
	"FLIGHTS": {
		"LIST_FILTER": {
			"upcoming": "aankomend",
			"upcoming_desc": "nog te vliegen of van de afgelopen 7 dagen",
			"older": "niet afgesloten (ouder)",
			"older_desc": "geplande vluchten van meer dan 7 dagen geleden, nog niet afgesloten",
			"historical": "beëindigd",
			"historical_desc": "gevlogen of geannuleerd"
		},
		"show_expired_on_flight_date": "toon verlopen op vluchtdatum ({{n}})",
		"BULK": {
		  "selected": "{{count}} geselecteerd (max. {{limit}})",
		  "clear_selection": "Selectie wissen",
		  "select_all_matching": "Alle gefilterde vluchten selecteren",
		  "actions": "Bulkactie",
		  "choose_action": "Actie kiezen",
		  "deselect_all": "Alles deselecteren",
		  "make_public": "Openbaar maken",
		  "make_private": "Privé maken",
		  "download_csv": "CSV downloaden",
		  "ACTION": {
		    "SET_VISIBILITY_PUB": "Vluchten openbaar maken",
		    "SET_VISIBILITY_PRI": "Vluchten privé maken",
		    "ADD_TAG": "Tag toevoegen",
		    "REMOVE_TAG": "Tag verwijderen",
		    "CANCEL": "Vluchten annuleren",
		    "DELETE": "Vluchten verwijderen"
		  },
		  "recent_actions": "Bulkacties van de laatste 24 uur",
		  "no_recent_actions": "Geen bulkacties in de laatste 24 uur",
		  "undone": "ongedaan gemaakt",
		  "undone_by": "Ongedaan gemaakt door {{user}}",
		  "too_many_matches": "{{total}} vluchten voldoen aan deze filter. Een bulkactie kan maximaal {{limit}} vluchten tegelijk aanpassen. Verfijn de zoekterm, periode of tagfilter, bijvoorbeeld per maand.",
		  "limit_reached": "Je kan maximaal {{limit}} vluchten selecteren voor een bulkactie. Verfijn de zoekterm, periode of tagfilter.",
		  "no_matches": "Geen vluchten voldoen aan deze filter.",
		  "confirm_selected": "{{count}} vluchten geselecteerd.",
		  "date_range": "Periode",
		  "will_update": "{{count}} worden aangepast",
		  "will_stay_unchanged": "{{count}} hebben deze instelling al",
		  "will_skip": "{{count}} worden overgeslagen",
		  "undo_hint": "Je kan deze actie binnen 24 uur één keer ongedaan maken.",
		  "apply": "Toepassen op {{count}} vluchten",
		  "updated": "{{count}} aangepast",
		  "unchanged": "{{count}} ongewijzigd",
		  "skipped": "{{count}} overgeslagen",
		  "restored": "{{count}} hersteld",
		  "not_restored": "{{count}} niet hersteld",
		  "undo": "Ongedaan maken",
		  "undo_available_until": "Ongedaan maken kan tot",
		  "SKIP": {
		    "NOT_FOUND": "vlucht bestaat niet meer",
		    "NOT_UPCOMING": "vlucht is geannuleerd of afgesloten",
		    "HAS_BOOKINGS_FUTURE": "heeft reservaties: annuleer deze vlucht apart zodat de passagiers verwittigd worden",
		    "HAS_BOOKINGS": "heeft reservaties",
		    "NOT_SCHEDULED": "enkel geplande vluchten kunnen verwijderd worden",
		    "ERROR": "onverwachte fout"
		  },
		  "UNDO_SKIP": {
		    "CHANGED_SINCE": "sindsdien gewijzigd, niet hersteld",
		    "NOT_FOUND": "vlucht bestaat niet meer",
		    "DELETED": "reservatie verwijderd",
		    "ON_OTHER_FLIGHT": "reservatie op een andere vlucht gepland",
		    "NOT_OPEN": "reservatie niet meer open",
		    "ERROR": "onverwachte fout"
		  }
		},
    "CANCEL": {
      "title": "vlucht annuleren",
      "reason_from_message": "reden: {{reason}}",
      "change_reason": "wijzigen",
      "cancel_and_send": "annuleren en bericht sturen",
      "cancel_and_send_crew": "annuleren en bericht sturen + crew",
      "cancel_only": "enkel annuleren",
      "cancel_only_warning": "de passagiers worden niet verwittigd",
      "confirm": "bevestigen",
      "already_sent": "annulatiebericht al verstuurd",
      "send_failed": "het bericht kon niet verstuurd worden — de vlucht is niet geannuleerd",
      "back": "terug"
    },
    "cancel_message_only": "enkel annulatiebericht sturen",
    "cancel_message_sent_chip": "annulatiebericht verstuurd — vlucht nog niet geannuleerd",
    "passengers_not_notified": "passagiers zijn niet verwittigd",
		"CHECKIN_LOG": {
			"title": "check-in piloot",
			"empty": "geen wijzigingen tijdens mobiele check-in",
			"signoff_cleared": "handtekening piloot gewist",
			"signoff_signed": "piloot heeft afgetekend"
		},
		"cancelled_bookings": {
			"title": "passagiers bij annulering",
			"send_message": "annulatiebericht versturen",
			"restore": "vlucht herstellen",
			"restore_confirm": "De vlucht wordt hersteld en de passagiers die erop stonden worden opnieuw toegevoegd. Boekingen die intussen op een andere vlucht staan blijven ongewijzigd.",
			"restore_done": "Vlucht hersteld, {{count}} boeking(en) opnieuw toegevoegd.",
			"restore_skipped": "Niet hersteld: {{skipped}}.",
			"skip_DELETED": "boeking bestaat niet meer",
			"skip_ON_OTHER_FLIGHT": "staat intussen op een andere vlucht",
			"skip_NOT_OPEN": "boeking is niet meer open"
		},
		"save": "bewaar",
		"reset": "reset default",
		"unknown": "onbekend",
		"CON": "bevestigd",
		"invited_by_sms": "uitgenodigd per sms",
		"DEC": "geweigerd",
		"MOR": "ochtend",
		"EVE": "avond",
		"CPF": "commerciële privé vlucht",
		"COF": "commerciële vlucht",
		"NCF": "recreatieve vlucht",
		"PRI": "niet gedeeld",
		"PUB": "gedeeld",
		"SCH": "gepland",
		"REA": "klaar",
		"MARK": {
			"SCH": "plan",
			"REA": "zet klaar",
			"CAN": "annuleer",
			"FIN": "beëindig"
		},
		"INFO": {
			"SCH": "bepaal alle vlucht details en markeer dan klaar",
			"REA": "goed gedaan! Deze vlucht is klaar voor lift-off",
			"CAN": "deze vlucht is geannuleerd, je kan ze verwijderen uit het systeem",
			"FIN": "deze vlucht is uitgevoerd. Goed gewerkt!"
		},
		"checkin": "check in",
		"CAN": "geannuleerd",
		"FIN": "beëindigd",
		"balloon": "ballon",
		"date": "datum",
		"period": "periode",
		"event": "event",
		"hour": "uur",
		"hourMeeting": "afspraakuur",
		"sunrise": "zonsopgang",
		"sunset": "zonsondergang",
		"flight_type": "type vlucht",
		"location": "opstijglocatie ",
		"visibility": "zichtbaarheid",
		"web": "web",
		"status": "status",
		"comment": "opmerkingen",
		"crew_comments": "crew opmerkingen",
		"pilot": "piloot",
		"pilot_status": "status",
		"action_needed": "actie nodig",
		"ground_crew": "crew",
		"pilot_and_crew": "piloot en crew",
		"not_enough_data": "onvoldoende gegevens",
		"answer_pilot_yes_no": "Antwoord PILOOT JA of PILOOT NEE",
		"pilot_yes": "PILOOT JA",
		"pilot_no": "PILOOT NEE",
		"Flight date cannot be set in the past": "vluchtdatum kan niet in het verleden vallen",
		"answer_crew_yes_no": "Antwoord CREW JA of CREW NEE",
		"crew_yes": "CREW JA",
		"crew_no": "CREW NEE",
		"flights": "vluchten",
		"flight_bookings": "reservaties",
		"UNK": "toegevoegd",
		"INV": "uitgenodigd per sms",
		"invite_all": "MSG uitnodiging allen",
		"inviteCount": "uitnodigingen",
		"invite_count_1": "uitnodiging",
		"mo": "ma",
		"tu": "di",
		"we": "wo",
		"th": "do",
		"fr": "vr",
		"sa": "za",
		"su": "zo",
		"invite": "stuur sms",
		"mail": "e-mail",
		"reply": "antwoord",
		"sms": "sms",
		"whatsapp": "WhatsApp",
		"whatsapp_sms": "WhatsApp (backup sms)",
		"message": "bericht",
		"message_whatsapp": "WhatsApp bericht",
		"message_sms_fallback": "SMS fallback bericht",
		"confirm": "bevestigen",
		"remove": "verwijder",
		"contactName": "contact naam",
		"bookingType": "reservatie type",
		"region": "regio",
		"passengers": "passagiers",
		"no_bookings_selected": "geen reservaties geselecteerd",
		"matching_bookings": "reservaties",
		"mismatching_bookings": "reservaties op een andere vlucht",
		"mismatchReasons": "vlucht matching",
		"add_all": "voeg allen toe",
		"add": "voeg toe",
		"add_and_confirm": "voeg toe + bevestig",
		"already_added": "al toegevoegd",
		"messages": "berichten",
		"calendar": "kalender",
		"download_manifest": "passagierslijst",
		"send_sms_reminder": "SMS herinnering",
		"update": "wijzig",
		"are_you_sure": "ben je zeker",
		"reminder_sms_will_be_sent": "herinnering SMS zal verzonden worden",
		"edit_sms": "bewerk SMS",
		"edit_wa": "bewerk WhatsApp",
		"preview_sms": "voorbeeld",
		"send": "stuur",
		"send_to_pax": "stuur naar PAX",
		"send_to_pax_and_crew": "stuur naar PAX en CREW",
		"send_up_url_with_sms": "stuur UP url met SMS",
		"send_up_url_with_msg": "stuur UP url met MSG",
		"upTitle": "Ga direct naar je persoonlijke passagierspagina via deze link!\n[persoonlijke link wordt meegestuurd]",
		"flightOptions": "vlucht opties",
		"flightOptionsTitle": "We nodigen u graag uit om met ons mee te varen op één van de volgende data:\n[persoonlijke lijst van vaarten met voldoende plaasten wordt meegestuurd]",
		"send_flightoptions_with_msg": "stuur vlucht opties met MSG",
		"sent": "verzonden",
		"message_has_been_sent": "bericht werd verzonden",
		"message_has_not_been_sent": "bericht werd niet verzonden",
		"not_sent": "niet verzonden",
		"not_confirmed_bookings_will_be_removed_from_flight": "de volgende, niet bevestigde, reservaties zullen verwijderd worden van de vlucht",
		"flight_will_be_cancelled": "Vlucht zal geannuleerd worden",
		"flight_will_be_finished": "Vlucht zal beëindigd worden",
		"flight_will_be_reopened": "Vlucht zal opnieuw in de planning komen",
		"yes_cancel_it": "ja, annuleer",
		"no_please": "neen",
		"cancel_sms_will_be_sent": "annuleer MSG zal verzonden worden",
		"not_cancelled": "niet geannuleerd",
		"flight_has_not_been_cancelled": "vlucht werd niet geannuleerd",
		"confirm_message": "ben je zeker om te verwijderen?",
		"flight_pilot_in_command": "pilot in command",
		"invite_by_sms": "stuur sms",
		"unsupported_phonenumber": "telefoonnummer wordt niet ondersteund",
		"sms_unclear": "onduidelijke sms",
		"no_pilot_in_command_selected": "geen pilot in command geselecteerd",
		"flight_crew": "crew",
		"no_crew_selected": "geen crew geselecteerd",
		"available_pilots_and_crew": "beschikbare piloten en crew",
		"select_pilot": "selecteer piloot",
		"select_crew": "selecteer crew",
		"other_flight": "andere vlucht",
		"add_as_crew": "crew",
		"add_as_pilot": "piloot",
		"warning": "waarschuwing",
		"creating_a_flight_can_lead_to_costs": "deze actie kan kosten genereren",
		"proceed": "ga verder",
		"cancel": "annuleer",
		"passenger_count": "passagiers",
		"crew_count": "crew",
		"type": "type",
		"no_pilot": "geen piloot",
		"seats": "passagiers ",
		"delete": "verwijder",
		"set_ready": "zet klaar",
		"address": "adres",
		"postalCode": "postcode",
		"city": "stad",
		"country": "land",
		"manifest": "passagierslijst",
		"certificates": "certificaten",
		"takeoffTime": "vertrek tijd",
		"landingLocation": "landing locatie",
		"landingDetails": "landing details",
		"total_weight": "totaal gewicht",
		"landingTime": "landing tijd",
		"flightTime": "vlieg tijd",
		"and": "en",
		"name": "naam",
		"ref": "referentie",
		"amount": "bedrag (EUR)",
		"weight": "gewicht",
		"signature": "handtekening",
		"reminder_sms": "herinnering SMS",
		"also_to_pilot_and_crew": "ook naar piloot en crew",
		"cancel_sms": "annuleer SMS",
		"no_flights_found": "geen vluchten gevonden",
		"no_location": "geen locatie",
		"show": "toon",
		"hide": "verberg",
		"lift": "lift",
		"lift_needed": "nodige lift",
		"lift_available": "draagvermogen",
		"lift_spare": "reserve draagvermogen",
		"lift_level_green": "draagvermogen OK",
		"lift_level_orange": "reserve draagvermogen laag",
		"lift_level_red": "reserve draagvermogen te laag",
		"lift_level_blue": "onderbeladen — kan onder minimum landingsmassa (MLM) landen",
		"lift_level_unknown": "liftgegevens onvolledig",
		"takeoff_location": "opstijglocatie",
		"temp": "temperatuur",
		"takeoff_height": "opstijghoogte",
		"maximum_height": "maximum hoogte",
		"temp_takeoff": "opstijgtemperatuur",
		"temp_takeoff_manual_hint": "manueel ingegeven — klik om terug de Meteoblue-temperatuur te gebruiken",
		"temp_max": "maximum hoogte temperatuur",
		"weather_qfe": "luchtdruk (QNH)",
		"weather_pmax": "maximum hoogte luchtdruk",
		"balloon_volume": "ballon volume",
		"balloon_temp": "max ballon temperatuur",
		"create_add": "voeg toe aan nieuwe vlucht",
		"weather": "weer",
		"copy_weather_to": "kopieer weer naar",
		"use_meteoblue": "gebruik meteoblue",
		"skeyes_ballooning_bulletin": "skeyes ballooning bulletin",
		"use_skeyes": "gebruik Skeyes",
		"weather_forecast": "weersvoorspelling",
		"no_weather_forecast": "er is geen weersvoorspelling beschikbaar",
		"windSummary": "samenvatting wind",
		"weather_source": "bron",
		"weather_source_forced": "officiële bron (weer instellingen)",
		"weather_forecast_date": "datum voorspelling",
		"vfr_visual": "zicht",
		"vfr_clouds": "wolkendek",
		"wind_gl": "wind grond niveau",
		"wind_gl_short": "wind GL",
		"wind_dir": "richting",
		"wind_gl_direction": "wind richting grond niveau",
		"wind_10": "wind 1000FT",
		"wind_10_direction": "wind richting 1000FT",
		"wind_20": "wind 2000FT",
		"wind_20_direction": "wind richting 2000FT",
		"wind": "wind",
		"clear": "clear",
		"fuel_spare": "reserve brandstof",
		"planned_flight_time": "geplande vliegtijd",
		"spare_flight_time": "reserve vliegtijd",
		"maximum_flight_time": "beschikbare vliegtijd",
		"select_balloon": "selecteer de ballon",
		"select_location": "selecteer de locatie",
		"offsets": "pas sunrise/sunset offsets aan",
		"flight_hour_will_be_calculated_based_on_sunset_minus_the_offset_minutes": "het uur van de vlucht wordt berekend op basis van zonsondergang (of zonsopgang) min het aantal offset minuten, afgerond naar beneden op het half uur. Negatieve waardes (zonsopgang bv.) zijn toegelaten.",
		"offset_sunrise": "offset sunrise (minuten)",
		"offset_sunset": "offset sunset (minuten)",
		"payment_overview": "betaaloverzicht",
		"go_back": "ga terug",
		"freeSpots": "vrije plaatsen",
		"traject": {
			"trajectory": "traject",
			"custom_flight_profile": "aangepast vlucht profiel",
			"duration": "duur",
			"duration_is_required": "duur is verplicht",
			"level": "niveau in hPa",
			"level_is_required": "niveau is verplicht",
			"save": "bewaar",
			"no_trajectory_without_meteo": "geen traject zonder weersvoorspelling",
			"update_custom_profile": "wijzig aangepast profiel",
			"refresh_weather": "vernieuw weer",
			"talking_to_meteoblue": "communicatie met meteoblue",
			"refresh_hint": "meteoblue werkt zijn weermodel regelmatig bij. Je kan opnieuw verversen 4 uur na de laatste update."
		},
		"LANDING": {
			"landing": "landing",
			"landing_details": "details",
			"map": "map",
			"no_details": "geen details ingevuld",
			"landing_data": "landingsgegevens kan je voorlopig enkel invullen in het mobiele check-in scherm van de vlucht",
			"refuelVolume": "getankt volume gas",
			"update_log": "wijzig log",
			"update_log_hint": "je kan hier enkel de landingsgegevens aanpassen. Open de vlucht om alle andere vluchtgegevens aan te passen.",
			"open_flight": "open vlucht"
		},
		"FILTER": {
			"date_range_filter": "datum filter",
			"from": "van",
			"till": "tot",
			"excluded": "uitgesloten",
			"no_date_filter_active": "geen datum filter actief",
			"enter_a_date_range": "geef een datum range in",
			"start_date": "start datum",
			"end_date": "eind datum",
			"month": "maand",
			"week": "week",
			"day": "dag",
			"flights": "vluchten"
		},
		"flight_no_bookings": "deze vlucht heeft nog geen boekingen",
		"mor_flight": "ochtend vlucht",
		"eve_flight": "avond vlucht",
		"mor_flights": "ochtend vluchten",
		"eve_flights": "avond vluchten",
		"no_mor_flights": "geen ochtend vluchten",
		"no_eve_flights": "geen avond vluchten",
		"responded_pilots": "gereageerde piloten",
		"delete_flight": "verwijder vlucht",
		"toggle_visibility": "verander zichtbaarheid",
		"tags": "tags",
		"COPY": {
			"copy_flight": "kopieer vlucht",
			"select_multiple_dates": "selecteer meerdere datums om dezelfde vlucht te kopiëren met dezelfde locatie, ballon, piloot en crew",
			"selected_dates": "geselecteerde datums",
			"no_tags": "geen tags",
			"copy": "kopieer"
		},
		"PILOTANDCREW": {
			"selected": "geselecteerd",
			"most_used": "meest gebruikt",
			"this_is_the_most_used_pilot_and_crew": "dit is de meest gebruikte piloot en crew voor deze ballon",
			"accept": "accepteer",
			"all_pilots_and_crew": "alle piloten en crew",
			"select": "kies"
		},
		"FREESPOTS": {
			"showAll": "Alle vluchten tonen",
			"showOverbookings": "Overboekingen tonen",
			"freeSpots": "Alle vluchten met {{count}} of meer vrije plaatsen tonen",
			"showMore": "Meer opties tonen"
		},
		"selected_flight": "Geselecteerde vlucht",
		"selected_flight_hint": "Deze reservatie is momenteel gepland op deze vlucht",
		"possible_flights": "Eerstkomende vluchten",
		"possible_flights_hint": "Dit zijn de eerstkomende vluchten waar deze reservatie op gepland kan worden, rekening houdend met vrije plaatsen en tag restricties",
		"balloon_cannot_accept_passengers": "Ballon kan geen passagiers accepteren",
		"balloon_in_use_tooltip": "De ballon wordt gebruikt op een andere vlucht met passagiers. Verander naar een andere ballon om passagiers hier toe te voegen.",
		"reduce_capacity_by_one_pax": "Capaciteit met één passagier verminderen",
		"reset_capacity": "Capaciteit opnieuw instellen",
		"has_open_amount_tooltip": "Deze vlucht heeft reserveringen met een openstaand bedrag"
	},
	"DISPLAYEDCOLUMNS": {
		"hint": "Selecteer kolommen en wijzig de volgorde met drag 'n drop volgens je voorkeur",
		"warning": "opgelet, je moet je voorkeuren opnieuw instellen na wijzigingen aan de kolom definities",
		"flightsUpcoming": "Kolommen voor aankomende vluchten",
		"flightsBooking": "Kolommen voor vluchten vanuit reservaties",
		"flightsHistory": "Kolommen voor historische vluchten",
		"bookingsOpen": "Kolommen voor openstaande reservaties",
		"bookingsHistory": "Kolommen voor historische reservaties",
		"bookingsPayment": "Kolommen voor opvolging betalingen",
		"bookingsDashboard": "Kolommen voor dashboard reservaties",
		"bookingsFlight": "Kolommen voor reservaties op een vlucht",
		"bookingsFlightEnd": "Kolommen voor reservaties op beëindigde vlucht",
		"bookingsFlightCancelled": "Kolommen voor reservaties van een geannuleerde vlucht",
		"bookingsFlightAll": "Kolommen voor reservaties op een vlucht",
		"bookingsFlightPayment": "Kolommen voor opvolging betalingen",
		"status": "status",
		"name": "ballon",
		"nameBadge": "ballon",
		"date": "datum",
		"event": "evenement",
		"hour": "uur",
		"location": "locatie",
		"pilot": "piloot",
		"crew": "crew",
		"bookings": "reservaties",
		"comments": "opmerkingen",
		"passengers": "passagiers",
		"passengersWeight": "gewicht",
		"action": "actie",
		"bookingDate": "reservatiedatum",
		"contactName": "contact naam",
		"phone": "telefoon",
		"region": "regio",
		"city": "stad",
		"preferredDate": "beschikbaarheid",
		"flightDate": "vlucht datum",
		"flightPeriod": "vlucht periode",
		"flight_balloon": "vlucht ballon",
		"flight_location": "vlucht locatie",
		"flight_pilot": "vlucht piloot",
		"totalAmount": "totaal bedrag",
		"paid_amount": "betaald",
		"openAmount": "saldo",
		"flight_confirmation": "vlucht bevestigen",
		"messages": "berichten",
		"up": "UP",
		"contactCard": "reservatie",
		"passengersCard": "passagiers",
		"mismatchReasons": "vlucht matching",
		"mobile_view": "zichtbaar op mobiel"
	},
	"MANIFEST": {
		"fuel_consumption": "brandstof verbruik",
		"fuel_needed": "brandstof nodig",
		"fuel_available": "brandstof beschikbaar",
		"load_chart_and_passenger_list": "Lift Berekening en Passagierslijst",
		"passenger_list": "Passagierslijst",
		"weather_conditions": "Weersomstandigheden",
		"fuel_calculations": "Brandstof berekening",
		"load_chart": "Lift berekening",
		"after_flight": "Na de vlucht",
		"visible_defects": "Zichtbare defecten",
		"yes_no": "Ja/Nee",
		"date": "Datum",
		"signature": "Handtekening",
		"defect": "Defect",
		"action": "Actie",
		"certificate": "Certficaat",
		"authority": "Authoriteit",
		"initials": "Initialen",
		"confirmation": "Dit bevestigt dat de gespecifieerde werken, tenzij anders vermeld, werden uitgevoerd in overeenstemming met PART-ML en dat hierdoor het luchtvaartuig beschouwd wordt als klaar voor vrijgave voor gebruik."
	},
	"LOCATIONS": {
		"name": "naam",
		"description": "beschrijving",
		"region": "regio",
		"address": "adres",
		"postalCode": "postcode",
		"city": "stad",
		"country": "land",
		"height": "hoogte",
		"maximum height": "maximum hoogte",
		"locations": "opstijglocaties",
		"confirm_message": "ben je zeker om te verwijderen?",
		"confirm": "bevestigen",
		"update": "wijzig",
		"delete": "verwijder",
		"regions": "regio's",
		"save": "bewaar",
		"add_location": "voeg opstijglocatie toe",
		"add_region": "voeg regio toe",
		"hot_airfield": "hot airfield",
		"coordinates": "coördinaten",
		"geolocate": "lokaliseer",
		"no_results": "geen resultaten",
		"contact": "contact",
		"takeoff_location": "opstijglocatie",
		"takeoff_location_subtitle": "De coördinaten van de opstijglocatie worden gebruikt voor de weersvoorspelling, traject en lift berekening.",
		"meetingpoint": "verzamellocatie",
		"meetingpoint_subtitle": "Het adres van de verzamellocatie wordt gecommuniceerd aan de passagiers (UP).",
		"same_as_takeoff": "zelfde als opstijglocatie",
		"meetingpointAddress": "adres verzamellocatie",
		"search_address": "zoek adres",
		"CONTACT": {
			"name": "naam",
			"type": "type",
			"comment": "opmerkingen",
			"phone": "telefoon",
			"email": "email",
			"when_to_contact": "wanneer te contacteren",
			"how_to_contact": "hoe te contacteren",
			"NOMSG": "contactpersoon moet niet elke vlucht verwittigd worden",
			"MAIL": "email",
			"SMS": "msg",
			"mail": "tijdens het voorbereiden van de vlucht, zal je de contactpersoon een email kunnen sturen",
			"sms": "tijdens het voorbereiden van de vlucht, zal je de contactpersoon een msg kunnen sturen",
			"no_message": "De contact persoon zal je niet kunnen verwittigen via email of msg",
			"add_sms_template": "voeg msg template toe",
			"add_mail_template": "voeg email template toe",
			"mail_template": "email template",
			"sms_template": "msg template",
			"warning_email": "je hebt nog geen mail gestuurd naar de contactpersoon",
			"warning_sms": "je hebt nog geen msg gestuurd naar de contactpersoon"
		}
	},
	"FLYABILITY": {
		"verdict_good": "goed om te vliegen",
		"verdict_marginal": "twijfelachtig",
		"verdict_nogo": "vermoedelijk niet vliegbaar",
		"no_assessment": "geen beoordeling beschikbaar",
		"all_within_limits": "alle parameters binnen je grenzen",
		"unknown_excluded": "geen gegevens voor {{parameters}} — niet meegerekend",
		"advisory": "Deze inschatting is enkel een hulpmiddel op basis van je eigen grenzen — de gezagvoerder beslist.",
		"param_windGl": "grondwind",
		"param_wind500": "wind op 500 m",
		"param_gustSpread": "windstoten boven grondwind",
		"param_precipitation": "neerslag",
		"param_lowClouds": "lage bewolking",
		"param_visibility": "zicht"
	},
	"FORECAST": {
		"no_mobile": "Meteo is momenteel niet beschikbaar op kleine schermen",
		"select_favorite": "Selecteer een locatie als favoriet om de meteoblue voorspelling te tonen",
		"no_forecast": "Er is geen meteo beschikbaar voor deze locatie. Controleer latitude en longitude",
		"remove_favorite": "verwijder favoriet",
		"mark_favorite": "markeer favoriet",
		"favorite_description": "deze locatie is je favoriete locatie. Op het dashboard tonen we de weersvoorpelling voor deze locatie",
		"non_favorite_description": "deze locatie is geen favoriete locatie. Markeer ze als favoriet om de weersvoorspelling te tonen op het dashboard",
		"meteo": "meteo",
		"time": "uur",
		"summary": "samenvatting"
	},
	"REGIONS": {
		"name": "naam",
		"locations": "opstijglocaties",
		"no_locations_yet": "nog geen locaties",
		"name_required": "naam verplicht",
		"change_color": "klik hier om de regiokleur te veranderen",
		"reset_color": "reset kleur",
		"confirm_color": "bevestig kleur",
		"cancel_color": "annuleer kleur",
		"openBookings": "open reservaties",
		"notusedyet": "nog geen reservaties",
		"move": "verplaats alle reservaties naar een andere regio",
		"select_target_region": "selecteer de nieuwe regio voor alle {0} reservatie in deze regio"
	},
	"EVENTS": {
		"new_event": "nieuw event",
		"information": "voeg een event toe op datum of laad de feestdagen",
		"new_crew_event": "nieuwe afspraak",
		"crew_information": "voeg een datum toe waarop je niet beschikbaar bent",
		"holidays": "feestdagen",
		"load_public_holidays_of_year_from_country": "laad feestdagen van {0} voor {1}",
		"date": "datum",
		"description": "beschrijving",
		"save": "bewaar",
		"cancel": "annuleer",
		"required": "verplicht",
		"crew": "crew",
		"NO": "niet beschikbaar",
		"YES": "beschikbaar",
		"MAYBE": "misschien beschikbaar",
		"UNK": "beschikbaarheid onbekend",
		"comment_availability": "Waarmee houden we best rekening op",
		"comment": "opmerking"
	},
	"SETTINGS": {
		"VARIANTS": {
      "duplicate": "dupliceren",
      "copySuffix": "(kopie)",
      "reasonCode": "annulatiereden",
      "reasonCodeHint": "Kies je deze reden bij het annuleren, dan staat dit bericht klaar. Een reden hoort bij maximaal één bericht.",
      "reasonGeneral": "— geen (algemeen bericht) —",
      "reasonTaken": "gebruikt door {{label}}",
      "reasonRemoved": "(verwijderde reden)",
      "default": "standaard",
		        "add": "variant toevoegen",
		        "remove": "variant verwijderen",
		        "label": "naam variant",
		        "labelHint": "Optioneel — onderscheidt meerdere teksten van hetzelfde berichttype (bv. \"ochtendvaart\", \"korte termijn\").",
		        "picker": "tekstversie",
		        "variant": "variant",
		        "waIssues": "WhatsApp Business kan deze tekst niet indienen",
		        "waRejected": "Afgekeurd door Meta",
		        "waResubmitHint": "Pas de tekst aan en bewaar — hij wordt automatisch opnieuw ter goedkeuring ingediend bij Meta.",
		        "wabaColumn": "WhatsApp-status",
		        "ISSUES": {
		            "VARIABLE_AT_START": "begint met een variabele",
		            "VARIABLE_AT_END": "eindigt op een variabele",
		            "ADJACENT_VARIABLES": "twee variabelen direct na elkaar",
		            "TOO_MANY_VARIABLES": "te veel variabelen voor de hoeveelheid vaste tekst",
		            "UNKNOWN_PLACEHOLDER": "onbekende variabele voor dit berichttype",
		            "TOO_LONG": "tekst is te lang",
		            "EMPTY_TEXT": "geen tekst"
		        }
		    },
		"user_default_language": "standaard gebruikerstaal",
		"submit": "bewaar",
		"preferences_language": "taal",
		"preferences_sms": "sms",
		"smsTitle": "titel",
		"smsTemplate": "template",
		"pilotInvitationSms": "MSG aan piloot",
		"example": "voorbeeld",
		"update": "wijzig",
		"crewInvitationSms": "MSG aan crew",
		"passengerInvitationSms": "MSG aan passagiers",
		"cancelSms": "annulatie MSG",
		"reminderSms": "herinnering MSG",
		"locationContactSms": "MSG aan contactpersoon",
		"emailTitle": "titel",
		"no_emailTitle": "geen titel",
		"emailType": "type",
		"emailTo": "email aan",
		"emailSubject": "onderwerp",
		"emailBody": "bericht",
		"emailAttachments": "bijlages",
		"emailAttachments_save_hint": "vergeet niet je template op te slaan na het toevoegen of verwijderen van bijlages",
		"emailTest": "email test",
		"mailFromEmail": "email account adres",
		"mailFromName": "email account naam",
		"mailReplyToEmail": "email account reply to adres",
		"mailAccountantName": "email naam boekhouder",
		"mailAccountantEmail": "email adres boekhouder",
		"bookingConfirmEmail": "Email bevestiging reservatie",
		"bookingFlightCancelEmail": "Email einde vlucht",
		"bookingFlightConfirmEmail": "Email passagiers van een vlucht",
		"crewFlightEmail": "Email vlucht details aan crew",
		"crewOtpEmail": "Email login instructies",
		"pilotFlightEmail": "Email vlucht details aan piloot",
		"flight_email": "Email vlucht details",
		"locationContactEmail": "Email locatie contact",
		"flight_email_passengers": "Email passagiers",
		"flight_sms_passengers": "SMS passagiers",
		"flight_msg_passengers": "MSG passagiers",
		"load_default": "laad een standaard tekst",
		"passenger_categories": "passagierscategorieen",
		"category_name": "naam",
		"category_description": "beschrijving",
		"category_child": "kind",
		"category_price": "prijs",
		"category_default": "standaard",
		"delete": "verwijder",
		"mobile_questions": "passagiersvragen (mobiel)",
		"question": "vraag",
		"kind": "type",
		"active": "actief",
		"title": "titel",
		"description": "beschrijving",
		"language": "taal",
		"texts": "teksten",
		"name": "naam",
		"address": "adres",
		"email": "email",
		"weight": "gewicht",
		"luggage": "bagage",
		"child": "kind",
		"accompany": "begeleiding",
		"pay": "betaling",
		"signature": "handtekening",
		"optional": "optioneel",
		"mandatory": "verplicht",
		"order": "volgorde",
		"titles": "vragen",
		"descriptions": "bijhorende teksten",
		"yes": "ja",
		"no": "neen",
		"nl": "nederlands",
		"fr": "frans",
		"en": "engels",
		"de": "duits",
		"es": "spaans",
		"id": "id",
		"download_sample": "download voorbeeld",
		"drag_and_drop_file_here": "drag en drop je bestand hier",
		"browse_for_file": "kies je bestand",
		"operator_settings": "operator instellingen",
		"operator_backup_and_sync": "backup en sync",
		"operator_bookings": "reservatie instellingen",
		"operator_flights": "vlucht instellingen",
		"operator_crew": "crew instellingen",
		"operator_myflight": "UP (Passengers App) instellingen",
		"operator_weather_source": "weer- en NOTAM-instellingen",
		"flyability": {
			"enabled": "vliegbaarheid tonen op de weerkaart",
			"disabled_hint": "Uit: de weerkaart en het vluchtdetail zien er precies uit zoals vandaag, zonder oordelen en zonder kleuren. Zet het aan om elk voorspellingsmoment tegen onderstaande grenzen te beoordelen.",
			"band_good": "goed",
			"band_marginal": "twijfelachtig",
			"band_nogo": "niet vliegen",
			"explain_windGl": "Gemiddelde windsnelheid aan de grond tijdens het vluchtvenster. Bepaalt of ventileren, opstijgen en landen veilig kan — dit is de grens waarop de meeste vluchten afgelast worden.",
			"explain_wind500": "Windsnelheid op ongeveer 500 meter, de hoogte waar een ballon het grootste deel van de vlucht zit. Bepaalt hoe snel en hoe ver je vliegt, en dus hoeveel landingsgebied je nodig hebt.",
			"explain_gustSpread": "Hoeveel harder de windstoten zijn dan de gelijkmatige grondwind. Windstoten van 8 kt bovenop een rustige wind van 5 kt betekenen nog altijd plotse rukken aan de ballon bij het ventileren en landen — daarom wordt dit apart beoordeeld van de wind zelf.",
			"explain_precipitation": "De zwaarste neerslag die tijdens het vluchtvenster verwacht wordt. Een natte ballon is zwaar en moet achteraf gedroogd worden, daarom houden de meeste operatoren de groene zone op nul.",
			"explain_lowClouds": "Het deel van de hemel dat bedekt is met wolken onder ongeveer 2 km. Veel lage bewolking betekent een lage wolkenbasis en weinig zicht op de grond: 0 % is een strakblauwe hemel, 100 % is volledig bewolkt.",
			"explain_visibility": "Hoe ver je horizontaal kunt zien. Je hebt het nodig om te navigeren, ander verkeer op te merken en tijdig een landingsweide te kiezen. Dit is de enige parameter waarbij meer beter is, dus de grenzen tellen hier omhoog.",
			"title": "grenzen voor vliegbaarheid",
			"hint": "De weerkaart kleurt elk voorspellingsmoment groen, oranje of rood op basis van deze grenzen. Laat een parameter op de standaardwaarde staan om de platformwaarde te blijven volgen.",
			"good_upto": "goed tot",
			"marginal_upto": "twijfelachtig tot",
			"good_from": "goed vanaf",
			"marginal_from": "twijfelachtig vanaf",
			"is_default": "standaard",
			"reset": "terug naar standaard",
			"reset_all": "alles terug naar standaard",
			"saved": "grenzen voor vliegbaarheid bewaard",
			"error_required": "beide waarden zijn verplicht",
			"error_negative": "waarden kunnen niet negatief zijn",
			"error_order": "de grens voor goed kan niet strenger zijn dan die voor twijfelachtig"
		},
		"weatherSource": {
		    "title": "officiële weerbron per land",
		    "hint": "Indien actief wordt de weerbron op de vlucht en het Operational Flight Plan (OFP) automatisch ingevuld met de officiële bron voor het land van de opstijglocatie, in plaats van vrije tekst.",
		    "mapped": "officiële weerbron per land verplichten",
		    "source": "weerbron",
		    "locations": "locaties",
		    "locationsWithoutCountry": "locaties zonder land (gelieve het land in te vullen)",
		    "addCountry": "land toevoegen"
		},
		"export": "export",
		"you_can_activate_a_daily_backup": "je kan een dagelijkse export in HTML toegestuurd krijgen op een specifiek e-mail adres. Van zodra je de export activeert, ontvang je meteen een export op het opgegeven e-mail adres, daarna elke dag rond 04u.",
		"daily_backup": "dagelijkse export",
		"backup_email": "E-mail adres",
		"only_update_when_inactive": "je kan het e-mail adres enkel veranderen als de dagelijkse export niet actief is",
		"exported_files": "geëxporteerde bestanden",
		"bookings": "alle open reservaties",
		"flights": "alle geplande vluchten",
		"vouchers": "alle cadeau bonnen",
		"flights_bookings_passengers": "alle geplande vluchten met de reservaties en passagiers van de vlucht",
		"calendarUrl": "kalender ICS URL",
		"you_can_subscribe_to_all_flights_in_your_personal_calendar": "je kan je abonneren op alle aankomende vluchten in je persoonlijke (smartphone) kalender",
		"geticsurl": "genereer ICS URL",
		"readthedocs": "lees de documentatie",
		"crew": {
			"title": "Crew",
			"shareBookings": "crew kan details zien van de reservaties in het dashboard",
			"shareBookingsHint": "als dit niet aangevinkt is, kan de crew enkel de vluchten zien waarvoor ze ingeschreven zijn, maar niet de details van de reservaties",
			"allowFlightSelection": "crew kan vluchten selecteren in de kalender",
			"allowFlightSelectionHint": "als dit niet aangevinkt is, kan de crew enkel de beschikbaarheid aangeven in de kalender, maar niet zelf de vluchten selecteren",
			"shareEvents": "deel kalendergebeurtenissen met crew",
			"shareEventsHint": "indien aangevinkt worden operator evenementen (bv. vakantie, bedrijfsevenementen) zichtbaar voor crew in hun kalender",
			"shareFlightTags": "deel vluchttags met crew",
			"shareFlightTagsHint": "indien aangevinkt worden vluchttags zichtbaar voor crew in hun kalender",
			"crewReady": {
				"title": "Crew ready melding",
				"channel": "meldingskanaal",
				"channelNone": "geen (uitgeschakeld)",
				"channelEmail": "e-mail",
				"channelWhatsApp": "WhatsApp",
				"channelBoth": "Beide (e-mail + WhatsApp)",
				"instructions": "crew instructies",
				"includePassengers": "passagiers opnemen in melding",
				"includeTrajectory": "trajectafbeelding opnemen in melding",
				"language": "taal van de melding",
				"hint": "De crew wordt automatisch geïnformeerd via WhatsApp of e-mail wanneer de vluchtstatus verandert naar gereed. De melding bevat vluchtgegevens en optioneel passagiers en traject.",
				"preview": "voorbeeld"
			}
		},
		"operator_notifications": "notificaties",
		"notifications": {
			"title": "E-mail notificaties",
			"title_calendar": "E-mail notificatie wijziging beschikbaarheid",
			"title_flightCrew": "E-mail notificatie wijziging piloot en/of crew van een vlucht",
			"calendar": "Ontvang een e-mail als de beschikbaarheid van crew en piloten wijzigt",
			"calendarHint": "als dit aangevinkt is, dan stuurt het systeem automatisch een overzichtelijke e-mail naar de operator en de crew 5 minuten nadat de crew of piloot één of meerdere beschikbaarheden heeft aangepast",
			"calendarClosing": "afsluittekst e-mail",
			"calendarClosingHint": "Deze afsluitende tekst wordt toegevoegd aan elke e-mail",
			"flightCrew": "Stuur een e-mail als je een piloot of crew toevoegt aan een vlucht",
			"flightCrewHint": "als dit aangevinkt is, dan stuur je automatisch een e-mail naar de piloot en crew als je ze toevoegt of verwijderd van een vlucht",
			"save": "bewaar"
		},
		"booking": {
			"title": "reservaties",
			"childAge": "leeftijd kind",
			"childAgeHint": "Elke passagier met deze leeftijd of jonger, zal automatische aangeduid worden als kind",
			"disabledPaymentTypes": "uitgeschakelde betaalmethodes",
			"disabledPaymentTypesHint": "de geselecteerde betaalmethodes zijn NIET beschikbaar",
			"none_of_the_paymentTypes_are_disabled": "geen enkele betaalmethode is uitgeschakeld",
			"disabledPaymentTypesSave": "bewaar betaalmethodes",
			"sources": "bronnen",
			"flightOptionsCount": "aantal vluchtopties",
			"flightOptionsCountHint": "Het aantal eerstvolgende ballonvaarten die geschikt zijn voor de reservatie, rekening houdend met het aantal passagiers en eventuele beperkingen (tags)."
		},
		"flight": {
			"title": "vluchten",
			"sunriseOffset": "zonsopgang offset",
			"sunriseOffsetHint": "het uur van de vlucht wordt berekend op basis van zonsopgang min het aantal offset minuten, afgerond naar beneden op het half uur.",
			"sunsetOffset": "zonsondergang offset",
			"sunsetOffsetHint": "het uur van de vlucht wordt berekend op basis van zonsondergang min het aantal offset minuten, afgerond naar beneden op het half uur.",
			"meetingTimeOffset": "verzameluur offset",
			"meetingTimeOffsetHint": "het uur van afspraak voor de vlucht wordt berekend op basis van het vlucht uur min het aantal offset minuten. Indien 0, dan wordt het uur van afspraak niet getoond.",
			"sunrise": "zonsopgang",
			"sunset": "zonsondergang",
			"hourMeeting": "afspraakuur",
			"hour": "opstijguur",
			"save": "bewaar offsets",
			"save_hint": "nieuwe offsets gelden alleen voor vluchten die vanaf nu worden aangemaakt",
			"save_and_update_hours": "bewaar offsets en update vluchturen",
			"save_and_update_hours_hint": "alle komende vluchten worden bijgewerkt met de nieuwe offsets",
			"cancelReason": "annuleringsreden",
			"cancelReasons": "annuleringsredenen",
			"cancelReasonsHint": "als een vlucht geannuleerd wordt, dan kan je de reden van annulatie aangeven",
			"cancelReasons_list_empty": "geen annuleringsredenen gevonden, voeg je eerste annuleringsreden toe",
			"new_cancelreason": "nieuwe annuleringsreden",
			"you_can_manage_all_cancelreasons_in_settings": "je kan alle annuleringsredenen beheren in de instellingen",
			"cancelreason_validation": "annuleringsreden is verplicht, min 3, max 50 karakters en moet uniek zijn",
			"defaultPeriod": "standaard periode",
			"defaultPeriodHint": "kies voor het aanmaken van een nieuwe vlucht standaard voor ochtend of avond vluchten",
			"morning": "ochtend",
			"evening": "avond",
			"duplicateProtection": "dubbele vluchtbescherming",
			"duplicateProtectionHint": "Voorkomt dat een ballon voor meerdere vluchten tegelijk wordt ingepland. Je kunt geen passagiers toevoegen aan een vlucht als dezelfde ballon op dat moment al een andere actieve vlucht heeft.",
			"duplicateProtection_enabled": "bescherming ingeschakeld",
			"duplicateProtection_disabled": "bescherming uitgeschakeld"
		},
		"myflight": {
			"title": "Quick Release UP (Passengers App)",
			"autoConfirm": "automatisch bevestigen",
			"autoConfirmHint": "als dit aangevinkt is, dan moet de operator de vlucht niet meer bevestigen",
			"autoConfirmEmailTemplate": "bevestigings e-mail sjabloon",
			"autoConfirmEmailTemplateHint": "selecteer een e-mail sjabloon om automatisch naar de passagier te sturen wanneer de reservatie bevestigd wordt",
			"noEmailTemplate": "geen automatische e-mail",
			"autoConfirmAPI": "automatisch bevestigen via API (website)",
			"autoConfirmAPIHint": "als dit aangevinkt is, dan wordt de vlucht automatisch bevestigd voor nieuwe reservaties die via de API (website) aangemaakt worden",
			"endOfSeason": "einde seizoen",
			"endOfSeasonHint": "als dit aangevinkt is, dan kunnen de passagiers geen vluchten meer aanvragen via UP",
			"flights": "Welke vluchten kan een passagier kiezen via UP?",
			"ALL": "alle vluchten, rekening houdend met de tag restricties",
			"REGIONAL": "regionale vluchten (vluchten die plaatsvinden in de regio van de reservatie)",
			"NONE": "geen vluchten (passagiers kunnen enkel hun namen en gewichten doorgeven)",
			"parameters": "parameters",
			"branding": "branding",
			"logo": "logo",
			"logoHint": "upload een logo dat getoond wordt in de UP app",
			"drag_and_drop_file_here": "drag en drop je .jpg of .png bestand hier (max 500kB)",
			"colors": "kleuren",
			"colorsHint": "klik op elke kleur om ze aan te passen aan je eigen huisstijl. Je kan een kleur kiezen uit het palette van je logo in de pop-up",
			"example": "voorbeeld",
			"reset": "reset kleuren",
			"save": "bewaar kleuren en logo",
			"primary_background_color": "achtergrond kleur van de app",
			"secondary_background_color": "achtergrond kleur van de tegels",
			"primary_foreground_color": "kleur van de tekst",
			"secondary_foreground_color": "kleur van de informatie tekst",
			"invalid_file_type_or_size": "ongeldig bestandstype of te groot bestand",
			"attachment_not_found": "Bijlage niet gevonden in opslag — verwijder en upload opnieuw",
			"translations": "Vertalingen",
			"change_translations": "Sommige teksten kunnen aangepast worden",
			"click_button_to_change_translations": "Open het login scherm van de UP-app voor passagiers met de knop hieronder. Login met een test reservatie of één van je bestaande reservaties. Overal waar het volgende icoontje staat, kan je de vertaling aanpassen.",
			"goto_api_settings": "Je moet een API key hebben om de vertalingen te kunnen wijzigen. Ga naar de API instellingen om een API key te genereren.",
			"update_translations": "Vertalingen aanpassen"
		},
		"cao": {
			"title": "CAO"
		},
		"sms": {
			"footerEnabled": "voettekst toevoegen aan MSG",
			"footerEnabledHint": "als dit aangevinkt is, dan wordt de voettekst niet toegevoegd aan de uitnodigings MSG"
		},
		"api": {
			"external_connection": "externe koppelingen",
			"external_connection_subtitle": "koppel je website of andere apps met Quick Release",
			"apiKey": "API Key",
			"generateApiKey": "API Key genereren",
			"noKeyMessage": "Je hebt nog geen API Key. Genereer een API Key om toegang te krijgen tot de API.",
			"documentation": "Documentatie",
			"documentationDescription": "Lees de documentatie voor meer informatie over de API.",
			"apiPlayground": "API-playground",
			"FlightAppDocumentation": "FlightApp documentatie",
			"FlightAppHint": "Koppel Quick Release met de erkende digitale logboeken van FlightApp. De beëindigde vaarten worden automatisch doorgestuurd naar FlightApp. Quick Release checkt de geldigheid van ballonnen en piloten bij FlightApp.",
			"FlightAppApikeyNotValid": "Fout: deze FlightApp API key is niet geldig",
			"FlightAppAircraftNotValid": "Fout: deze FlightApp ballon werd niet gevonden in het systeem. Controleer de callsign.",
			"FlightAppPilotNotValid": "Fout: deze FlightApp piloot werd niet gevonden in het systeem. Controleer het email adres.",
			"addFlightAppApiKey": "FlightApp API Key toevoegen",
			"hideApiKey": "API Key verbergen",
			"showApiKey": "API Key tonen",
			"copyToClipboard": "Kopiëren naar klembord",
			"newApiKey": "Nieuwe API Key",
			"newApiKeyHint": "Voer de nieuwe API Key in",
			"updating_keys": "de API keys worden aangepast"
		},
		"callback": {
			"title": "Callback-URL",
			"subtitle": "Stel een callback-URL in om meldingen over reservatie gebeurtenissen te ontvangen. De JSON-payload bevat de bookingId, flightId en de nieuwe status van de boeking",
			"url": "Callback-URL",
			"noUrlMessage": "Er is geen callback-URL ingesteld. Klik op de knop hieronder om er een in te stellen.",
			"setUrl": "Callback-URL instellen",
			"saveUrl": "URL opslaan",
			"clearUrl": "URL wissen"
		},
		"security": {
			"title": "Beveiliging",
			"twoFA": "Twee-factor authenticatie",
			"description": "De twee-factor authenticatie voegt een extra laag van beveiliging toe aan je account. Op niet vertrouwde apparaten zal je een extra 6-cijferige code moeten invoeren die je krijgt via een e-mail.",
			"enableTwoFA": "Twee-factor authenticatie inschakelen",
			"enableTwoFAConfirm": "Twee-factor authenticatie inschakelen zal je meteen uitloggen. Ben je zeker?",
			"mandatory": "Twee-factor authenticatie is verplicht vanaf 01 Januari 2026"
		},
		"MESSAGING": {
			"ENABLED": "Berichten zijn ingeschakeld",
			"ENABLED_HINT": "Berichten worden verzonden via WhatsApp. Als WhatsApp niet beschikbaar is, kan SMS-fallback worden gebruikt.",
			"DISABLED": "Berichten zijn uitgeschakeld",
			"DISABLED_HINT": "Neem contact op met Quick Release om berichten in te schakelen voor uw account.",
			"STATUS_CONNECTED": "WhatsApp verbonden",
			"STATUS_DISCONNECTED": "WhatsApp niet verbonden",
			"FALLBACK_WARNING": "WhatsApp is niet beschikbaar. Bericht wordt via SMS verzonden (kosten van toepassing).",
			"RECONNECT_INSTRUCTIONS": "Verbind uw WhatsApp-apparaat opnieuw door de QR-code hieronder te scannen."
		},
		"checkinNotificationSms": "check-in notificatie MSG",
		"bookingConfirmationSms": "reservatie bevestiging MSG",
		"platformUpLink": "UP-link (vast sjabloon)",
		"platformFlightOptions": "vaartvoorstellen (vast sjabloon)",
		"checkinNotificationEmail": "Email check-in notificatie",
		"checkin_title": "Online check-in",
		"checkin_mode_none": "geen check-in",
		"checkin_mode_none_hint": "Check-in wordt niet gebruikt.",
		"checkin_mode_pdf": "PDF check-in (manueel)",
		"checkin_mode_pdf_hint": "Druk het check-in blad met je instructies af; passagiers tekenen op papier op de vluchtdag.",
		"checkin_mode_online": "PDF + online check-in",
		"checkin_mode_online_hint": "Passagiers checken vooraf online in via de passagiersapp; het PDF blad blijft beschikbaar. Een notificatiekanaal (e-mail of WhatsApp) is verplicht.",
		"checkin_days_before": "Dagen voor de vlucht",
		"checkin_notification_channel": "Check-in notificatiekanaal",
		"checkin_instructions": "Check-in instructies (Markdown)",
		"checkin_save_instructions": "check-in instructies opslaan",
		"checkin_load_default": "Standaard instructies laden",
		"checkin_preview": "Voorbeeld",
		"checkin_schedule_explanation": "Wanneer check-in is ingeschakeld, kunnen passagiers online inchecken {{days}} dagen voor hun vlucht via de passagiersapp. Er wordt elke dag om 10:00 (Belgische tijd) automatisch een melding verstuurd naar bevestigde boekingen waarvan het check-in venster geopend is.",
		"checkin_passenger_explanation": "Deze tekst wordt getoond tijdens de online check-in (de passagier moet bevestigen deze te hebben gelezen en begrepen) en wordt afgedrukt op het PDF check-in blad boven de handtekeningen. Na online check-in wordt de reservatie alleen-lezen in de app.",
		"checkin_channel_title": "Notificatiekanaal",
		"checkin_inapp_title": "check-in tekst",
		"checkin_email_preview_title": "E-mail notificatie",
		"checkin_email_preview_subject": "Onderwerp",
		"checkin_whatsapp_preview_title": "WhatsApp notificatie",
		"checkin_email_template_hint": "Dit sjabloon kan worden aangepast in Instellingen → E-mail sjablonen",
		"checkin_sms_template_hint": "Dit sjabloon kan worden aangepast in Instellingen → SMS/WhatsApp sjablonen. De reservatielink wordt automatisch als apart bericht verstuurd."
	},
	"REPORTS": {
		"flights": "vluchten",
		"bookings_open": "open reservaties",
		"bookings": "nieuwe reservaties",
		"vouchers": "bonnen",
		"payments": "betalingen",
		"sms": "MSG"
	},
	"MAIL": {
		"hide": "verberg details",
		"show": "toon details",
		"sent": "verzonden",
		"error": "verzending mislukt"
	},
	"TENANT_ACTIONS": {
		"WHATSAPP_PAIR_REQUIRED": "WhatsApp herverbinden vereist. Je berichten worden pas verzonden nadat je de nieuwe QR-code hebt gescand.",
		"WHATSAPP_SESSION_DISCONNECTED": "Je WhatsApp is niet verbonden. Herverbind om berichten te kunnen blijven versturen.",
		"cta": "Nu herverbinden",
		"dismiss": "Melding sluiten"
	},
	"SUBSCRIPTION": {
		"WA_CLOUD": {
		        "billable": "WhatsApp Business betalend (Meta)",
		        "free": "WhatsApp Business gratis",
		        "info": "Indicatief — Meta factureert WhatsApp Business-berichten rechtstreeks op je eigen Meta-account."
		    },
		"sms_available": "beschikbaar in abonnement",
		"sms_sent": "verzonden SMS",
		"wa_sent": "verzonden WhatsApp",
		"recalculate": "opnieuw berekenen",
		"pct_sms_used": "% van je SMS zijn verbruikt",
		"sms_info": "Neem contact op met ons om bijkomende SMS te bestellen van zodra je meer dan 95% verbruikt hebt",
		"sms_warning": "Je hebt 95% of meer van je SMS tegoed verbruikt.",
		"LOW_SMS_BALANCE": "Laag SMS-saldo - SMS-fallback kan mislukken wanneer WhatsApp niet beschikbaar is.",
		"order_sms": "Bestel nu bijkomend SMS tegoed",
		"sms_ignore_warning": "Verberg meldingen over het SMS verbruik",
		"pct_plan_used": "% van je seats zijn verbruikt",
		"plan_seats_used": "totale capaciteit ballonnen",
		"plan_valid_until": "geldig tot",
		"plan_info": "Neem contact op met ons om over te schakelen naar een hoger plan als de beschikbare capaciteit niet meer volstaat of om je huidig abonnement te vernieuwen",
		"plan_expiring": "Je abonnement verloopt binnenkort. Verleng je abonnement om onderbrekingen te voorkomen.",
		"plan_expiring_days": "Je abonnement verloopt over {days} dagen. Verleng je abonnement om onderbrekingen te voorkomen.",
		"plan_expired_grace_days": "Je abonnement is verlopen. Normaal gebruik eindigt over {days} dagen. Verleng onmiddellijk.",
		"plan_expired_since_days": "Je abonnement is {days} dagen geleden verlopen. Verleng om Quick Release te blijven gebruiken.",
		"plan_expired": "Je abonnement is verlopen en het normaal gebruik is afgelopen. Verleng om Quick Release te blijven gebruiken.",
		"plan_invalid_grace_days": "Je abonnement is niet geldig. Normaal gebruik eindigt over {days} dagen. Verleng onmiddellijk.",
		"plan_invalid_expired": "Je abonnement is niet geldig. Normaal gebruik is afgelopen. Verleng onmiddellijk om Quick Release te blijven gebruiken.",
		"manage_subscription": "Abonnement beheren",
		"EXPIRED_MESSAGE": "Abonnement verlopen. Verleng om verder te gaan.",
		"blocked": "Abonnement verlopen. Verleng om verder te gaan.",
		"custom_plan_title": "Aangepast abonnementsplan",
		"custom_plan_subtitle": "Handmatige vernieuwing vereist",
		"custom_plan_message": "Je hebt een aangepast abonnement.",
		"custom_plan_contact": "Neem contact op met het Quick Release team om een aanpassing of vernieuwing aan te vragen."
	},
	"TAGS": {
		"delete": "verwijder tag",
		"enabled": "ingeschakeld",
		"enable_tag": "tag inschakelen",
		"disabled": "uitgeschakeld",
		"disable_tag": "tag uitschakelen",
		"save": "tag opslaan",
		"new_tag": "nieuwe tag aanmaken",
		"tag_name": "tag naam",
		"tag_type": "tag type",
		"select_tag_color": "selecteer kleur",
		"color": "kleur",
		"tag_already_added": "tag is al toegevoegd",
		"edit": "wijzig tag",
		"flight_tags": "vlucht tags",
		"tags": "tags",
		"show_on_dashboard": "toon op het dashboard",
		"allowedFlightTags": "toegelaten",
		"not_restricted": "Alle reservaties toegelaten",
		"all_flights_allowed": "alle vluchten toegelaten, tenzij specifieke reserveringstags vereist zijn",
		"onlyAllowedFlightTags": "enkel deze reserveringstags toegelaten",
		"no_bookings_allowed": "geen reserveringen toegelaten"
	},
	"LOGBOOK": {
		"no_logbook_found": "geen logboek gevonden",
		"update_log_details": "Update log details",
		"new_logs_since": "Nieuwe logs sinds",
		"new_logs_since_beginning": "Nieuwe logs sinds begin",
		"total_new_logs": "Aantal nieuwe logs:",
		"total_flight_time": "Totale vliegtijd:",
		"add": "Voeg toe",
		"log": "log",
		"logs": "logs",
		"refresh": "Vernieuw",
		"logs_in_logbook": "Logs in logboek",
		"total_logs": "Aantal logs:",
		"latest_log": "Laatste log:",
		"export": "Exporteer",
		"send_to_flightapp": "Stuur naar FlightApp",
		"delete_log": "Verwijder log",
		"confirm_delete_log": "Deze log verwijderen?",
		"confirm_delete_log_body": "Hiermee verwijder je de log uit het logboek. Deze actie kan niet ongedaan gemaakt worden.",
		"start_date": "Startdatum",
		"initial_hours": "Vlieguren vóór logboek",
		"initial_hours_hint": "Uren uit papieren vliegboek",
		"total_logged_time": "Gelogde vliegtijd",
		"total_overall_time": "Totale vliegtijd",
		"settings": "Logboek instellingen",
		"setup_logbook": "Logboek instellen",
		"start_date_hint": "Begin van het digitale logboek. Vluchten vóór deze datum horen bij het papieren logboek — vul hun totalen hieronder in; vluchten vanaf deze datum worden geteld vanuit Quick Release. Oudere digitale vluchten blijven zichtbaar, grijs.",
		"before_start_date": "Vóór de startdatum — papieren tijdperk, niet meegeteld in de totalen",
		"hours": "uren",
		"minutes": "Minuten",
		"save_settings": "Opslaan",
		"settings_saved": "Logboekinstellingen opgeslagen",
		"initial_flights": "Vluchten vóór logboek",
		"initial_flights_short": "vooraf",
		"total_flights": "Totaal aantal vluchten",
		"flights": "vluchten",
		"logged_short": "gelogd",
		"stats_since": "Statistieken sinds",
		"logbook_title": "Logboek",
		"up_to_date": "Bijgewerkt",
		"pending_short": "toe te voegen",
		"from_system_pending": "uit het systeem, nog niet toegevoegd",
		"logged_flights": "Gelogde vluchten"
	},
	"IMAGES": {
		"hint": "De afbeeldingen die je uploadt kunnen gebruikt worden bij het versturen van WhatsApp berichten",
		"images": "afbeeldingen",
		"upload_new_images": "Upload nieuwe afbeeldingen",
		"drag_and_drop_images_here": "Sleep afbeeldingen hierheen",
		"max_files_reached": "Maximum aantal afbeeldingen bereikt",
		"browse_for_images": "Bladeren naar afbeeldingen",
		"supported_formats": "Ondersteunde formaten",
		"max_size_5mb": "max grootte 5MB",
		"uploading": "Uploaden",
		"image_library": "Afbeeldingenbibliotheek",
		"no_images_found": "Geen afbeeldingen gevonden",
		"delete_image": "Verwijder afbeelding"
	},
	"INVOICE": {
		"LOADING": "Facturen laden...",
		"EMPTY_STATE": "Geen facturen gevonden van de afgelopen 4 jaar",
		"TABLE": {
			"TITLE": "Facturen",
			"SUBTITLE": "Overzicht van uw facturen",
			"INFO": "Hier vindt u al uw facturen van de afgelopen 4 jaar. Klik op het downloadicoon om een factuur te downloaden.",
			"INVOICE_CODE": "Factuurnummer",
			"AMOUNT": "Bedrag",
			"DATE": "Datum",
			"STATUS": "Status",
			"ACTIONS": "Acties",
			"DOWNLOAD_TOOLTIP": "Factuur downloaden"
		},
		"STATUS": {
			"PAID": "Betaald",
			"SENT": "Verzonden",
			"REMINDED": "Herinnerd",
			"SUMMATION": "Aanmaning",
			"EXPIRED": "Verlopen",
			"DRAFT": "Concept"
		}
	},
	"ORDER": {
		"LOADING": "Bestellingen laden...",
		"EMPTY_STATE": "Geen bestellingen gevonden van de afgelopen 4 jaar",
		"TABLE": {
			"TITLE": "Bestellingen",
			"AMOUNT": "Bedrag",
			"DATE": "Datum",
			"STATUS": "Status",
			"ITEMS": "Items",
			"PLAN": "Plan",
			"SUBTITLE": "Overzicht van uw bestellingen",
			"INFO_PENDING": "U kunt items toevoegen aan een openstaande bestelling of deze in zijn geheel verwijderen.",
			"INFO_CONFIRMED_TITLE": "Na bevestiging:",
			"INFO_CONFIRMED_1": "U ontvangt een bestelbevestiging per mail",
			"INFO_CONFIRMED_2": "Uw bestelling wordt verwerkt en goedgekeurd",
			"INFO_CONFIRMED_3": "U ontvangt de factuur per mail",
			"INFO_CONFIRMED_4": "Het nieuwe plan of credits worden actief"
		},
		"STATUS": {
			"PENDING": "In afwachting",
			"CONFIRMED": "In verwerking",
			"APPROVED": "Goedgekeurd",
			"CANCELLED": "Geannuleerd"
		},
		"ACTIONS": {
			"CONFIRM": "Bevestigen",
			"DELETE": "Verwijderen",
			"APPROVE": "Goedkeuren",
			"CANCEL": "Annuleren"
		}
	},
	"DEBTOR_VALIDATION": {
		"TITLE": "Facturatieconfiguratie vereist",
		"SUBTITLE": "Uw debiteurgegevens moeten worden geconfigureerd",
		"MESSAGE": "Neem contact op met het Quick Release Team om uw facturatiegegevens te configureren en automatische verlenging en upgrade mogelijk te maken."
	},
	"NEW_ORDER": {
		"TITLE": "Nieuwe bestelling",
		"SUBTITLE": "Voeg items toe aan uw bestelling",
		"INFO_SMS": "Bestel extra tegoed: 1 of meerdere pakketten van 100 SMS of van 1000 SMS.",
		"INFO_PLAN": "Automatisch berekend op basis van uw abonnementsstatus en balloncapaciteit. Bij een upgrade betaalt u alleen het verschil.",
		"SUBTITLE_PLAN": "Automatisch berekend op basis van uw abonnementsstatus en balloncapaciteit. Bij een upgrade betaalt u alleen het verschil.",
		"SUBTITLE_SMS": "Bestel extra tegoed: 1 of meerdere pakketten van 100 SMS of van 1000 SMS.",
		"PLAN": {
			"TITLE": "Plan vernieuwing/upgrade",
			"EMPTY_MESSAGE": "Geen plannen beschikbaar",
			"NAME": "Plan",
			"MAX_SEATS": "Maximum capaciteit"
		},
		"UNIT_PRICE": "Eenheidsprijs",
		"QUANTITY": "Hoeveelheid",
		"ORDER_QUANTITY": "Hoeveelheid",
		"TOTAL": "Totaal",
		"CREDIT_AUTO_ADDED": "Tegoed automatisch toegepast",
		"ALREADY_IN_ORDER": "Reeds in bestelling",
		"ADD_TO_ORDER": "Toevoegen aan bestelling",
		"SMS": {
			"TITLE": "SMS",
			"UNIT_PRICE": "Prijs per pakket",
			"PER_PACKAGE": "Per pakket",
			"ORDER_QUANTITY": "Aantal pakketten",
			"TOTAL_SMS": "Totaal SMS"
		},
		"SUCCESS": "Item toegevoegd aan bestelling",
		"ERROR_LINE": "Fout bij het toevoegen van orderregel",
		"ERROR_ORDER": "Fout bij het maken van bestelling",
		"SUBMITTING": "Bestellingen plaatsen...",
		"ORDER_PROCESSING": "Er wordt momenteel een bestelling verwerkt. U kunt geen nieuwe bestellingen toevoegen totdat deze is goedgekeurd of geannuleerd.",
		"CONFIRM_DIALOG": {
			"TITLE": "Bestelling bevestigen",
			"MESSAGE": "U staat op het punt een bestelling te plaatsen.",
			"ORDER": "Bestelling",
			"TOTAL": "Totaal",
			"VAT_EXCL": "BTW excl.",
			"VAT_21": "BTW 21%",
			"TOTAL_WITH_VAT": "Totaal incl. BTW",
			"VAT_REVERSE_CHARGE_NOTE": "Opmerking: BTW verlegd kan van toepassing zijn op uw bestelling.",
			"VAT_REVERSE_CHARGE_SHORT": "(BTW verlegd kan van toepassing zijn)",
			"NO_PAYMENT_OBLIGATION": "Na goedkeuring van uw bestelling ontvangt u een factuur met betalingsverplichting.",
			"AGREE_TERMS": "Ik ga akkoord met de",
			"TERMS_LINK": "algemene voorwaarden",
			"CONFIRM_ORDER": "Bestelling bevestigen"
		}
	},
	"CHECKIN": {
		"not_all_checked_in": "Niet alle passagiers zijn online ingecheckt",
		"proceed_warning": "{{count}} van {{total}} bevestigde reservaties zijn niet online ingecheckt. Wil je doorgaan?",
		"opens_on": "Check-in opent op {{date}}",
		"checked_in": "ingecheckt",
		"checkin_open": "Check-in open",
		"invite_sent_at": "check-in uitnodiging verstuurd op {{date}}",
		"invite_not_sent": "nog geen check-in uitnodiging verstuurd",
		"send_invite": "check-in uitnodiging versturen",
		"invite_sent_success": "check-in uitnodiging verstuurd",
		"send_invite_all": "check-in uitnodiging naar alle openstaande boekingen versturen",
		"send_invite_all_confirm": "Check-in uitnodiging versturen naar {{count}} boekingen?",
		"invites_status_sent": "{{count}} uitnodiging(en) verstuurd",
		"invites_status_planned": "{{count}} gepland op {{date}}",
		"invite_planned_on": "check-in uitnodiging gepland op {{date}}",
		"send_now": "nu versturen",
		"preview_subject": "Je vlucht staat klaar voor check-in – {{date}} – {{location}}",
		"preview_greeting": "Beste {{name}},",
		"preview_body": "Je ballonvaart op <strong>{{date}}</strong> staat nu open voor online check-in.",
		"preview_body2": "Voltooi de check-in voor je groep ({{count}} passagiers) vóór de vluchtdatum. Tijdens de check-in wordt je gevraagd de veiligheidsinstructies te lezen en te bevestigen.",
		"preview_cta": "Nu inchecken",
		"preview_footer": "Heb je vragen? Neem dan contact met ons op.",
		"preview_wa_body": "Je ballonvaart op **{{date}}** staat nu open voor online check-in.",
		"preview_wa_body2": "Voltooi de check-in voor je groep ({{count}} passagiers) vóór de vluchtdatum.",
		"preview_wa_link": "Ga direct naar je persoonlijke passagierspagina via deze link!",
		"signature_sheet": "check-in handtekeningenlijst",
		"acknowledge": "Ik heb de bovenstaande informatie gelezen en begrepen",
		"pdf_check_in": "CHECK-IN",
		"pdf_passenger_manifest": "Passagierslijst",
		"pdf_safety_briefing": "Veiligheidsbriefing",
		"pdf_please_read": "Lees vóór het instappen",
		"pdf_balloon_operator": "Luchtballonoperator",
		"pdf_acknowledgement": "BEVESTIGING",
		"pdf_passenger": "Passagier",
		"pdf_signature": "Handtekening",
		"pdf_morning_flight": "Ochtendvlucht",
		"pdf_evening_flight": "Avondvlucht",
		"pdf_date": "DATUM",
		"pdf_balloon": "BALLON",
		"pdf_pic": "PILOOT",
		"pdf_takeoff": "OPSTIJGEN",
		"pdf_pic_on_file": "Handtekening PIC aanwezig",
		"pdf_local_time": "Lokale tijd",
		"pdf_page": "Pagina {{current}} van {{total}}",
		"pdf_manifest_subtitle": "{{pax}} passagiers · {{bookings}} reservaties"
	},
  "NOTAM": {
    "title": "NOTAM's",
    "panel_title_combined": "weer en NOTAM",
    "tooltip_count": "{{count}} NOTAM('s) — open de vlucht voor details",
    "none_known": "geen relevante NOTAM's bekend",
    "none_known_short": "geen NOTAM's bekend",
    "no_data": "geen NOTAM-gegevens voor deze locatie",
    "stale": "NOTAM-gegevens konden niet vernieuwd worden — laatste update {{time}}",
    "unavailable": "NOTAM-gegevens niet beschikbaar",
    "retry": "opnieuw proberen",
    "updated": "NOTAM-gegevens bijgewerkt {{time}}",
    "disclaimer": "Enkel ter ondersteuning — de officiële briefingplicht vóór de vlucht blijft bij de gezagvoerder (PIC).",
    "horizon_hint": "NOTAM's worden meestal pas kort voor de datum gepubliceerd, controleer opnieuw dichter bij de vlucht",
    "wide_area": "achtergrondmeldingen (ruim gebied / AIP)",
    "show_text": "toon originele NOTAM-tekst",
    "hide_text": "verberg originele NOTAM-tekst",
    "period": "actieve periode",
    "schedule": "dagschema",
    "altitude_band": "hoogteband",
    "connect_hint": "koppel je Autorouter-account om NOTAM-waarschuwingen te zien",
    "reconnect_hint": "herkoppel je Autorouter-account om NOTAM-waarschuwingen te vernieuwen",
    "connect_link": "open instellingen",
    "location_warning": "{{count}} NOTAM('s) op deze locatie voor het vluchtvenster",
    "CATEGORY": {
      "RESTRICTION": "luchtruimbeperking",
      "WARNING": "navigatiewaarschuwing",
      "OBSTACLE": "obstakel",
      "AERODROME": "vliegveld",
      "UNCLASSIFIED": "niet geclassificeerd"
    },
    "SETTINGS": {
      "title": "Luchtruim / NOTAM",
      "explanation": "NOTAM-waarschuwingen op vluchten, de trajectkaart en het dashboard vereisen een eigen (gratis) autorouter.aero-account. Quick Release haalt NOTAM-gegevens op onder de autorisatie van jouw account.",
      "disclaimer": "NOTAM-waarschuwingen zijn enkel ter ondersteuning; de officiële briefingplicht vóór de vlucht blijft bij de gezagvoerder (PIC).",
      "connect": "Autorouter-account koppelen",
      "reconnect": "Autorouter-account herkoppelen",
      "disconnect": "ontkoppelen",
      "disconnect_confirm": "Autorouter-account ontkoppelen? De opgeslagen autorisatie en de opgehaalde NOTAM-gegevens worden verwijderd.",
      "connected_as": "gekoppeld als",
      "connected_since": "sinds",
      "status_disconnected": "geen Autorouter-account gekoppeld",
      "reauth_warning": "de Autorouter-autorisatie is verlopen of ingetrokken — herkoppel om NOTAM-gegevens te blijven ontvangen",
      "connected_snack": "Autorouter-account gekoppeld",
      "denied_snack": "Autorouter-koppeling geweigerd",
      "error_snack": "Autorouter-koppeling mislukt — probeer opnieuw"
    }
  },
  "WEEKPLANNER": {
    "matrix": {
      "availability": "beschikbaarheid",
      "availability_tooltip": "Aantal beschikbare piloten en crew — hover op de bolletjes voor namen",
      "availability_empty": "Nog geen beschikbaarheidsbeheer. Laat piloten en crew zelf hun beschikbaarheid invullen, dan zie je hier per dag wie kan varen.",
      "start_crew_login": "Start met crew login",
      "pilots_available": "beschikbare piloten",
      "crew_available": "beschikbare crew",
      "open_balloon": "Open het ballondetail",
      "seats": "plaatsen",
      "add_balloon": "Ballon toevoegen",
      "no_balloons": "Nog geen ballonnen. Voeg je eerste ballon toe om vluchten te plannen.",
      "no_flights": "Geen vluchten deze week.",
      "show_idle_balloons": "Ballonnen zonder vlucht ({{count}})",
      "hide_idle_balloons": "Verberg ballonnen zonder vlucht",
      "add_flight_for": "Vlucht toevoegen —",
      "open_flight_tooltip": "Open het vluchtdetail (of Ctrl/Cmd-klik op de cel)",
      "fly_ok": "Vliegbaar",
      "fly_wind": "Windwaarschuwing",
      "fly_rain": "Niet vliegbaar — neerslag",
      "fly_nogo_wind": "Niet vliegbaar — wind"
    },
    "availability": {
      "yes": "beschikbaar",
      "maybe": "misschien",
      "no": "niet beschikbaar",
      "unknown": "niet ingevuld"
    },
    "create": {
      "new_location_option": "+ Nieuwe locatie…",
      "no_locations": "Je hebt nog geen opstijglocaties. Maak de eerste aan.",
      "new_location": "Nieuwe locatie",
      "new_location_placeholder": "bv. Brugge – Minnewater",
      "new_location_note": "GPS, toelating en contact vul je later aan in het locatiedetail.",
      "save_location": "Locatie opslaan",
      "location_created": "Locatie {{name}} aangemaakt.",
      "location_created_default": "Locatie {{name}} aangemaakt — ook je standaardlocatie voor weer en zon."
    },
    "planner": {
      "available_drag": "beschikbaar — sleep naar een vlucht",
      "no_people": "nog geen piloten of crew",
      "assign_to": "Toewijzen aan…",
      "add_pilot": "Piloot",
      "add_crew": "Crew",
      "edit": "Bewerk de vluchtinfo",
      "edit_done": "Klaar met bewerken",
      "publish": "Publiceer naar crew",
      "unpublish": "Verberg voor crew",
      "mark_finished": "Markeer als uitgevoerd",
      "cancel": "Annuleer vlucht",
      "restore": "Herstel vlucht",
      "staffing": "Piloot, BE-chauffeur en crew",
      "published_chip": "crew",
      "published_tooltip": "Zichtbaar voor de crew",
      "pilot": "Piloot",
      "driver": "BE-chauffeur",
      "crew": "Crew",
      "takeoff_temperature": "Temperatuur bij opstijgen",
      "trajectory": "traject",
      "lift_free": "{{kg}} kg vrij",
      "capacity_warning_title": "Dit overschrijdt de capaciteit van de ballon",
      "capacity_warning_body": "{{total}} passagiers op {{capacity}} plaatsen. Toch doorgaan?",
      "lift_warning_title": "Weinig lift op deze vlucht",
      "lift_warning_body": "Nog maar {{lift}} kg lift vrij. Toch toewijzen?",
      "person_already_assigned": "{{name}} staat al op {{flight}} in dit dagdeel.",
      "cancel_on_flight_page": "Deze vlucht heeft bevestigde boekingen: annuleer ze op de vluchtpagina zodat de passagiers verwittigd worden.",
      "preferred_of": "vaste ploeg van {{balloons}}",
      "propose_crew": "Vaste ploeg voorstellen",
      "propose_tooltip": "Zet {{names}} op de vlucht van {{balloon}}",
      "apply_all": "Alles toepassen"
    },
    "toast": {
      "flight_updated": "Vlucht bijgewerkt — weekdata opnieuw opgehaald.",
      "booking_confirmed": "Boeking bevestigd — bevestigingsmail verstuurd.",
      "balloon_updated": "Ballon bijgewerkt.",
      "save_failed": "Opslaan mislukt — probeer opnieuw."
    },
    "pool": {
      "oldest_first": "oudste eerst",
      "clear_search": "wis",
      "new_booking": "Nieuwe reservatie",
      "filters": "filters",
      "count_tooltip": "aantal binnen de huidige zoekopdracht",
      "chip_to_confirm": "te bevestigen",
      "chip_unplanned": "niet ingepland",
      "chip_voucher": "bon vervalt",
      "chip_open_amount": "openstaand bedrag",
      "chip_favourite": "favoriet",
      "clear_filters": "wis filters",
      "col_name": "Naam",
      "col_contact": "Contact",
      "col_pax": "Pers. · gewicht",
      "col_info": "Info",
      "col_comment": "Opmerking",
      "col_flight": "Vlucht",
      "col_actions": "Acties",
      "no_match": "Geen boekingen voor deze filters.",
      "flight_tooltip": "Open de vlucht — slepen verplaatst de boeking",
      "unplanned": "niet ingepland",
      "confirm": "Bevestig",
      "load_more_n": "Laad meer ({{n}})"
    },
    "panel": {
      "kind_flight": "Vlucht",
      "kind_balloon": "Ballon",
      "kind_booking": "Reservatie",
      "kind_person": "Persoon",
      "kind_location": "Locatie",
      "back": "Terug naar weekplanner",
      "close": "Sluit",
      "not_found": "Niet gevonden — misschien verwijderd.",
      "balloon": "Ballon",
      "status": "Status",
      "status_SCH": "gepland",
      "status_REA": "klaar voor vertrek",
      "status_FIN": "uitgevoerd",
      "status_CAN": "geannuleerd",
      "sun": "Zon",
      "sunrise": "zonsopgang",
      "sunset": "zonsondergang",
      "yes": "ja",
      "no": "nee",
      "crew_section": "Bemanning",
      "bookings": "Reservaties",
      "no_bookings_on_flight": "Nog geen reservaties op deze vlucht.",
      "heading": "Verwachte richting",
      "distance": "Afstand",
      "landing_zone": "Landingszone",
      "logbook": "Logboek",
      "takeoff_time": "Opstijguur",
      "landing_time": "Landingsuur",
      "landing_place": "Landingsplaats",
      "fuel": "Verbruik (flessen)",
      "open_page": "Open volledige pagina",
      "passenger_seats": "passagiersplaatsen",
      "passenger_seats_label": "Passagiersplaatsen",
      "basics": "Basis",
      "registration": "Registratie",
      "to_complete": "nog aan te vullen",
      "envelope": "Envelop",
      "envelope_manufacturer": "Fabrikant",
      "envelope_volume": "Volume (m³)",
      "envelope_type": "Type",
      "basket_burner": "Mand & brander",
      "basket_type": "Mandtype",
      "burner_type": "Brander",
      "cylinders": "Aantal flessen",
      "insurance": "Verzekering",
      "insurance_company": "Maatschappij",
      "due_date": "Vervaldatum",
      "maintenance": "Onderhoud",
      "last_inspection": "Laatste inspectie",
      "envelope_hours": "Vlieguren envelop",
      "flights_this_week": "Vluchten deze week",
      "no_flights": "Geen vluchten gepland.",
      "booking_detail": "Reservatiedetail",
      "contact": "Contact",
      "phone": "Telefoon",
      "email": "E-mail",
      "city": "Gemeente",
      "passengers": "Passagiers",
      "preferred": "Gewenst",
      "not_chosen": "nog niet gekozen",
      "not_planned": "Niet ingepland.",
      "booking_status_OPEN": "open",
      "booking_status_ADDE": "toegevoegd — te bevestigen",
      "booking_status_INVI": "uitgenodigd",
      "booking_status_CONF": "bevestigd",
      "booking_status_COMP": "afgerond",
      "booking_status_CANC": "geannuleerd",
      "region": "Regio",
      "payment": "Betaling",
      "to_pay": "Te betalen",
      "paid": "Betaald",
      "voucher": "Cadeaubon",
      "booking_code": "Boncode",
      "valid_until": "Geldig tot",
      "passenger_n": "Passagier {{n}}",
      "open_flight": "Open vlucht",
      "availability_this_week": "Beschikbaarheid deze week",
      "profile": "Profiel",
      "license_number": "Licentienummer",
      "license_expiry": "Licentie geldig tot",
      "medical_until": "Medische keuring tot",
      "driver_licence_be": "Rijbewijs BE",
      "launch_site": "Opstijglocatie",
      "default_for_weather": "standaardlocatie voor weer en zon",
      "default_location": "Standaardlocatie",
      "no_flights_location": "Geen vluchten vanaf deze locatie.",
      "location_detail": "Locatiedetail",
      "gps": "GPS-coördinaten",
      "address": "Adres",
      "contact_person": "Contactpersoon",
      "access_parking": "Toegang & parking",
      "preferred_crew": "Vaste ploeg",
      "preferred_crew_note": "Op basis van eerdere toewijzingen.",
      "preferred_crew_of": "Vaste ploeg van",
      "no_preferred_balloon": "Nog geen vaste ballon — volgt uit de toewijzingen."
    },
    "meteo": {
      "title": "Meteo",
      "no_default_location": "geen standaardlocatie",
      "follows_selection": "volgt de geselecteerde dag",
      "today_hint": "vandaag — selecteer een dag in de matrix",
      "sun": "zon {{rise}} – {{set}}",
      "pill_good": "vliegbaar",
      "pill_marginal": "twijfelachtig",
      "pill_nogo": "niet vliegbaar",
      "pill_unknown": "geen voorspelling",
      "pill_tooltip_good": "Vliegbaar — wind binnen de limieten",
      "pill_tooltip_marginal": "Twijfelachtig — windstoten boven de limiet",
      "pill_tooltip_nogo": "Niet vliegbaar — neerslag of wind boven de limieten",
      "pill_tooltip_unknown": "Geen voorspelling voor dit dagdeel",
      "no_forecast": "geen voorspelling voor deze dag",
      "row_hour": "Uur",
      "row_weather": "Weer",
      "row_temp": "Temp (°C)",
      "row_ground": "Grond",
      "row_wind": "Wind (kn)",
      "row_gust": "Windstoten (kn)",
      "row_pressure": "Druk (hPa)",
      "row_clouds": "Bewolking",
      "row_visibility": "Zicht (km)",
      "legend": "gouden uren — vluchtvensters rond zonsopgang ({{rise}}) en zonsondergang ({{set}}) · barbs: volle veer = 10 kn, halve = 5 kn",
      "updated": "bijgewerkt"
    },
    "myWeek": {
      "title": "Mijn week — {{name}}",
      "hint": "beschikbaarheid: klik om te wisselen · sleep naar andere dagen om te kopiëren",
      "my_availability": "mijn beschikbaarheid",
      "flights": "Vaarten",
      "click_to_fill": "klik om in te vullen",
      "own_pilot": "Mijn vlucht — ik vlieg",
      "own_crew": "Mijn vlucht — ik rijd mee",
      "published": "Gepubliceerde vlucht",
      "join": "Ik ga mee",
      "saved": "Beschikbaarheid opgeslagen — de planner ziet dit meteen.",
      "cleared": "Beschikbaarheid gewist.",
      "error_FLIGHT_HAS_CREW": "Iemand anders gaat al mee met deze vlucht.",
      "error_FLIGHT_NOT_PUBLISHED": "Deze vlucht is niet meer gepubliceerd.",
      "error_FLIGHT_NOT_SCHEDULED": "Deze vlucht is niet meer gepland.",
      "error_NOT_ON_FLIGHT": "Je staat niet meer op deze vlucht.",
      "error_ALREADY_PILOT": "Je bent al piloot op deze vlucht."
    },
    "theme": {
      "title": "Thema",
      "light": "Licht",
      "dark": "Donker",
      "system": "Systeem"
    }
  }
}
